export default {
    id: "पहचान",
    dashboard: "डैशबोर्ड",
    warning: "चेतावनी",
    users: "उपयोगकर्ताओं",
    farms: "फार्म",
    animals: "जानवरों",
    action: "कार्य",
    actionList: "कार्रवाई की सूची",
    drugInventory: "ड्रग इन्वेंटरी",
    inseminatorStatistics: "सेमिनेटर सांख्यिकी",
    organizationNTR: "संगठन एनटीआर",
    genotypePerformance: "जीनोटाइप प्रदर्शन",
    semenAutomation: "वीर्य स्वचालन",
    activityLogs: "गतिविधि लॉग",
    username: "उपयोगकर्ता नाम",
    title: "शीर्षक",
    deactivated: "निष्क्रिय",
    name: "नाम",
    email: "ईमेल",
    emailAddress: "मेल पता",
    mobileNum: "मोबाइल नंबर",
    emailOrMobile: "ईमेल/मोबाइल",
    role: "भूमिका",
    roles: "भूमिकाएँ",
    department: "विभाग",
    status: "दर्जा",
    pages: "पृष्ठों",
    departments: "विभागों",
    password: "पासवर्ड",
    cancel: "रद्द करना",
    submit: "जमा करना",
    error: "गलती",
    success: "सफलता",
    Browse: "ब्राउज़",
    orDropYourFileCsvXlsXlsxHere: "या अपनी फ़ाइल (CSV, XLS, XLSx) यहाँ छोड़ दें",
    search: "खोज",
    apply: "आवेदन करना",
    select: "चुनना",
    previous: "पहले का",
    mandatory: "अनिवार्य",
    dropYourFileHere: "या अपनी फ़ाइल (CSV, XLS, XLSx, PDF, Docx, PNG, JPEG) यहां छोड़ें",
    restoreDefault: "डिफ़ॉल्ट बहाल",
    pending: "लंबित",
    completed: "पुरा होना।",
    remove: "निकालना",
    update: "अद्यतन",
    removeFile: "फ़ाइल को हटाएं",
    uploadFile: "फ़ाइल अपलोड करें",
    pleaseChoosePreferedLanguage: "कृपया अपनी पसंदीदा भाषा चुनें",
    edit: "संपादन करना",
    activate: "सक्रिय",
    deactivate: "निष्क्रिय करें",
    recievedOrders: "प्राप्त आदेश",
    chartRepresentation: "चार्ट प्रतिनिधित्व",
    nameIsRequired: "नाम आवश्यक है",
    export: "निर्यात",
    noFilesAvailable: "कोई फ़ाइल उपलब्ध नहीं है",
    selectDepartmentToshowRoles: "भूमिकाएँ दिखाने के लिए एक विभाग का चयन करें",
    selectDepartmentWithActiveRoles: "सक्रिय भूमिकाओं वाले विभाग का चयन करें",
    nameCanContainOnlyAlphabets: "नाम में केवल अक्षर हो सकते हैं",
    nameMustBeLessThan15Chars: "नाम 30 वर्णों से कम का होना चाहिए",
    emailRequired: "ईमेल की जरूरत है",
    invalidEmailFormat: "अमान्य ईमेल प्रारूप",
    mobNumReq: "मोबाइल नंबर आवश्यक है",
    invalidMobFormat: "अमान्य मोबाइल नंबर प्रारूप।",
    passwordRequired: "पासवर्ड की आवश्यकता है",
    departmentReq: "विभाग की आवश्यकता है",
    roleReq: "भूमिका आवश्यक है",
    unableToUpdate: "अद्यतन करने में असमर्थ",
    orignalName: "मूल नाम",
    uploadedDate: "अपलोड करने की तिथि",
    fileName: "फ़ाइल का नाम",
    importNum: "आयात संख्या",
    languagePreferences: "भाषा वरीयता",
    pleaseTryAgainAfterSometime: "कृपया कुछ देर बाद प्रयास करें",
    noChanges: "कोई बदलाव नहीं",
    nothingchanged: "कुछ भी नहीं बदला",
    pleaseChooseAnImageFile: "कृपया एक छवि फ़ाइल चुनें",
    fileIsTooBigSelectUnder1MB: "आपकी फ़ाइल बहुत बड़ी है! ",
    phoneShouldHave10Chars: "फ़ोन में 10 अक्षर होने चाहिए",
    onlyCSVAllowed: "केवल CSV फ़ाइल की अनुमति है",
    loadingPleaseWait: "लोड हो रहा है कृपया प्रतीक्षा करें",
    manager: "प्रबंधक",
    administrator: "प्रशासक",
    Comingsoon: "जल्द आ रहा है",
    totalAnimals: "कुल पशु",
    receivedOrders: "प्राप्त आदेश",
    drugs: "ड्रग्स",
    detailedAnalysis: "विस्तृत विश्लेषण",
    barGraphRepOfActiveUsersAndDeactivateUsers: "सक्रिय उपयोगकर्ताओं और निष्क्रिय उपयोगकर्ताओं का बार ग्राफ़ प्रतिनिधित्व",
    barGraphRepOfRegAnimalsVsFarm: "पंजीकृत पशु बनाम फार्म का बार ग्राफ प्रतिनिधित्व",
    roleNumber: "भूमिका संख्या",
    roleName: "भूमिका का नाम",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    admin: "व्यवस्थापक",
    addRole: "भूमिका जोड़ें",
    addRoles: "भूमिकाएँ जोड़ें",
    permissions: "अनुमतियां",
    sr: "सीनियर",
    moduleName: "मोड्यूल का नाम",
    view: "देखना",
    deptNo: "विभाग संख्या",
    selectByCategory: "श्रेणी के अनुसार चयन करें",
    weeklyAnalytics: "साप्ताहिक विश्लेषण",
    pregnancy: "गर्भावस्था",
    analytics: "एनालिटिक्स",
    calendar: "पंचांग",
    productName: "प्रोडक्ट का नाम",
    volumeSold: "वॉल्यूम बिक गया",
    recordPoints: "रिकॉर्ड अंक",
    inStock: "स्टॉक में",
    revenue: "आय",
    stockStatus: "स्टॉक की अवस्था",
    barChart: "बार चार्ट",
    lineChart: "पंक्ति चार्ट",
    indexReturns: "इंडेक्स रिटर्न",
    chart: "चार्ट",
    time: "समय",
    production: "उत्पादन",
    customization: "अनुकूलन",
    recordsPerPage: "प्रति पृष्ठ अभिलेखॉ",
    noDataAvailable: "कोई डेटा मौजूद नहीं",
    reporting: "रिपोर्टिंग",
    optional: "वैकल्पिक",
    note: "टिप्पणी",
    notes: "टिप्पणियाँ",
    date: "तारीख",
    kG: "किलोग्राम",
    weight: "वज़न",
    type: "प्रकार",
    lessthan3Month: "<3 महीना",
    lessthan6Month: "<6 महीना",
    lessthan7Month: "<7 महीना",
    lastWeek: "पिछले सप्ताह",
    thisWeek: "इस सप्ताह",
    lessthanOneYear: "<1 साल",
    lessthanTwoYear: "<2 साल",
    lessthanThreeYear: "<3 साल",
    lessthanFourYear: "<4 साल",
    yes: "हाँ",
    no: "नहीं",
    of: "का",
    notSpecified: "निर्दिष्ट नहीं है",
    days: "दिन",
    day: "दिन",
    aDay: "एक दिन",
    years: "साल",
    year: "वर्ष",
    unit: "इकाई",
    units: "इकाइयों",
    to: "को",
    profile: "प्रोफ़ाइल",
    logOut: "लॉग आउट",
    Unit: "इकाई",
    otherSettings: "अन्य सेटिंग",
    somethingWentWrong: "कुछ गलत हो गया।",
    toDo: "ऐसा करने के लिए",
    loadingData: "डेटा लोड हो रहा है...",
    taskNumber: "कार्य संख्या",
    taskName: "कार्य का नाम",
    startDate: "आरंभ करने की तिथि",
    dueDate: "नियत तारीख",
    reason: "कारण",
    quantity: "मात्रा",
    cost: "लागत",
    noRecordFound: "कोई रिकॉर्ड नहीं मिला",
    dailyUpdates: "दैनिक अद्यतन",
    weeklyUpdates: "साप्ताहिक अपडेट",
    moduleAccessed: "मॉड्यूल एक्सेस किया गया",
    typesOfAccess: "पहुँच के प्रकार",
    userId: "उपयोगकर्ता पहचान",
    lastLogin: "आखरी लॉगइन",
    terminalID: "टर्मिनल आईडी",
    geographicalAccessPoint: "भौगोलिक पहुंच बिंदु",
    iPAddress: "आईपी ​​पता",
    fileAccessed: "फ़ाइल एक्सेस की गई",
    functionAccessed: "फंक्शन एक्सेस किया गया",
    webPageURL: "वेब पेज यूआरएल",
    accessType: "पहुंच प्रकार",
    unsuccessfulLoginAttempts: "असफल लॉगिन प्रयास",
    customerAddress: "ग्राहक का पता",
    orderdate: "आर्डर की तारीख",
    postageDate: "डाक तिथि",
    postID: "पोस्ट आईडी",
    packingTechnician: "पैकिंग तकनीशियन",
    packingTechnicia: "पैकिंग तकनीक",
    packEdit: "पैक संपादित करें",
    batchNumber: "बैच संख्या",
    collectionTechnician: "संग्रह तकनीशियन",
    collectionTechnicia: "संग्रह तकनीक",
    preparationTechnicia: "तैयारी तकनीक",
    preparationTechnician: "तैयारी तकनीशियन",
    approvedManually: "मैन्युअल रूप से स्वीकृत",
    researcher: "शोधकर्ता",
    dateOfApproval: "अनुमोदन का दिनांक",
    approvalEdit: "स्वीकृति संपादित करें",
    searchByAllExceptDate: "दिनांक को छोड़कर सभी द्वारा खोजें",
    approval: "अनुमति",
    collection: "संग्रह",
    postage: "डाक",
    pack: "सामान बाँधना",
    straws: "तिनके",
    createdAt: "पर बनाया गया",
    sireID: "साहब आईडी",
    economicIndexValue: "आर्थिक सूचकांक मूल्य",
    latestCollectionDate: "नवीनतम संग्रह तिथि",
    locationId: "स्थान आईडी",
    lastUpdated: "आखरी अपडेट",
    print: "छाप",
    save: "बचाना",
    tax: "कर",
    phoneNo: "फोन नंबर",
    exportAsPDF: "पीडीएफ के रूप में निर्यात करें",
    statusUpdated: "स्थिति अद्यतन",
    statusNotUpdated: "स्थिति अद्यतन नहीं",
    inProgress: "चालू",
    assignedTo: "को सौंपना",
    taskId: "टास्क आईडी",
    createdDate: "सृजित दिनांक",
    numberOfAnimals: "जानवरों की संख्या",
    healthRecordSubmittedSuccess: "स्वास्थ्य रिकॉर्ड सफलतापूर्वक सबमिट किया गया",
    healthRecordSubmitted: "स्वास्थ्य रिकार्ड प्रस्तुत किया।",
    InseminationRecordSubmittedSuccesful: "गर्भाधान रिकॉर्ड सफलतापूर्वक सबमिट किया गया",
    inseminationRecordSubmitted: "गर्भाधान रिकॉर्ड प्रस्तुत किया।",
    actionListDailyTask: "कार्य सूची - दैनिक कार्य",
    sinceLastYear: "पिछले वर्ष से",
    sinceLastQuarter: "पिछली तिमाही से",
    sinceLastMonth: "पिछले महीने के बाद से",
    sinceLastWeek: "पिछले सप्ताह से",
    drugWithdrawPeriod: "ड्रग निकासी अवधि",
    diagnosisName: "निदान का नाम",
    animalWithNoGenetype: "इस जानवर के पास कोई जीनोटाइप डेटा पंजीकृत नहीं है। ",
    nameOfPreviousOwner: "पिछले मालिक का नाम",
    avatarSize: "अवतार का आकार 1 एमबी से कम होना चाहिए!",
    testDestination: "परीक्षण गंतव्य",
    animalNotAdded: "पशु नहीं जोड़ा गया",
    registerationSuccessful: "सफल पंजीकरण",
    backToAnimalList: "पशु सूची को लौटें",
    addAnotherAnimal: "एक और जानवर जोड़ें",
    animalDetailsUpdated: "पशु विवरण सफलतापूर्वक अपडेट किया गया",
    animalUpdatedSuccessfully: "पशु सफलतापूर्वक अपडेट किया गया",
    animalNotUpdated: "पशु अद्यतन नहीं",
    notMember: "सदस्य नहीं हैं?",
    requestAccess: "अनुरोध का उपयोग",
    typePassword: "कृपया पासवर्ड टाइप करें।",
    minChars: "न्यूनतम 6 वर्ण",
    typeConfirmPassword: "पासवर्ड की पुष्टि करें टाइप करें",
    passConfig: "पासवर्ड की पुष्टि मेल नहीं खाती।",
    invalidEmailMobile: "अमान्य ईमेल/मोबाइल प्रारूप",
    passwordNotEmpty: "पासवर्ड खाली नहीं हो सकता",
    passwordLength: "पासवर्ड की लंबाई 8 वर्णों से कम नहीं हो सकती",
    cityVillage: "शहर / गांव",
    districtRegion: "जिला / क्षेत्र",
    alreadyHaveAnAccount: "पहले से ही एक खाता है?",
    genetypeUpdated: "जेनोटाइप अपडेट किया गया",
    genetypeNotUpdated: "जेनोटाइप अपडेट नहीं किया गया",
    sellTrade: "बेचें / व्यापार करें",
    milkingDevon: "बिक्री के लिए दुहना डेवोन ब्रीडिंग स्टॉक",
    detailedDescription: "विस्तृत विवरण",
    longPara: "अमेरिकन मिल्किंग डेवोन बुल्स बछिया और गायें। ",
    contactSeller: "विक्रेता से संपर्क कारें",
    enterListingTitle: "लिस्टिंग शीर्षक दर्ज करें",
    livestocktype: "पशुधन प्रकार",
    uploadImage: "एक छवि अपलोड करें",
    mobilePhone: "मोबाइल फोन नंबर",
    myLivestock: "मेरा पशुधन",
    livestockObservations: "पशुधन अवलोकन",
    selectFromRegisteredAnimals: "पंजीकृत पशुओं की सूची में से चयन करें",
    selectOption: "विकल्प चुनें",
    selectTypeObservation: "अवलोकन के प्रकार का चयन करें",
    attachVeteinaryDocument: "पशु चिकित्सा दस्तावेज संलग्न करें",
    addsensorReading: "सेंसर पढ़ना जोड़ें",
    myDocument: "मेरे दस्तावेज़",
    enterAKeyword: "एक कीवर्ड दर्ज करें",
    documentType: "दस्तावेज़ का प्रकार",
    registerEditLivestock: "पशुधन को पंजीकृत/संपादित करें",
    editLivestockProfile: "पशुधन प्रोफ़ाइल संपादित करें",
    copy: "प्रतिलिपि",
    dateOfRegister: "रजिस्टर की तारीख",
    livestockType: "पशुधन प्रकार",
    registerNewLivestock: "नया पशुधन पंजीकृत करें",
    enterUniqueTag: "अद्वितीय टैग दर्ज करें",
    color: "रंग",
    gender: "लिंग",
    male: "नर",
    female: "महिला",
    damm: "बाँध",
    siree: "सर ई",
    dateOfSaleAuction: "बिक्री/नीलामी बिक्री की तिथि",
    auctionRecord: "डेथलिस्ट का नीलामी रिकॉर्ड",
    distinguishingFeatures: "विशिष्ठ सुविधाओं",
    keywordListing: "कीवर्ड या लिस्टिंग आईडी",
    adType: "विज्ञापन प्रकार",
    activeListingFund: "1 सक्रिय लिस्टिंग मिली",
    setupSensors: "सेंसर सेट करें",
    serialNumber: "क्रमिक संख्या",
    sensorLocation: "सेंसर स्थान",
    sensorType: "सेंसर प्रकार",
    installationDate: "स्थापना की तिथि",
    ExpirationDate: "समाप्ति तिथि",
    addGeo: "जियोलोकेशन जोड़ें",
    addMoreSensors: "अधिक सेंसर जोड़ें",
    trackAndTrace: "खोज और पता",
    createNewShipment: "एक नया शिपमेंट बनाएँ",
    workflowReference: "वर्कफ़्लो संदर्भ",
    invoiceDate: "चालान की तारीख",
    trackShipment: "शिपमेंट ट्रैक करना",
    totalShipments: "कुल लदान",
    activeShipment: "सक्रिय लदान",
    completedObjectives: "पूर्ण उद्देश्य",
    processedPayments: "संसाधित भुगतान",
    pointOfDestination: "गंतव्य बिंदु",
    sellerInformation: "विक्रेता जानकारी",
    selectSellerConsignor: "विक्रेता/प्रेषक का चयन करें",
    pointOfOrigin: "उद्गम स्थल",
    buyerInfo: "क्रेता सूचना",
    selectBuyerConsignor: "क्रेता/प्रेषक का चयन करें",
    addSensorTriggers: "सेंसर ट्रिगर्स जोड़ें",
    processPayments: "प्रक्रिया भुगतान",
    defineShippingContract: "शिपिंग अनुबंध को परिभाषित करें",
    addDigitize: "जोड़ना",
    currentlyOnFarm: "वर्तमान में फार्म पर है",
    addSire: "साहब जोड़ें",
    addApproval: "स्वीकृति जोड़ें",
    addCollection: "संग्रह जोड़ें",
    addStraws: "स्ट्रॉ डालें",
    addPack: "पैक जोड़ें",
    addPostage: "डाक खर्च जोड़ें",
    searchBySire: "साहब द्वारा खोजें",
    anyDataChangeMightBeLost: "कोई भी डेटा परिवर्तन खो सकता है",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "क्या आप बचत करना चाहेंगे या बिना सहेजे छोड़ना चाहेंगे",
    leave: "छुट्टी",
    stay: "रहना",
    animalFarm: "पशु फार्म",
    animalFarmH: "पशु फार्म",
    animalOrigin: "पशु उत्पत्ति",
    animalOriginH: "पशु उत्पत्ति",
    farmOfOrigin: "उत्पत्ति का खेत",
    farmOfOriginH: "उत्पत्ति का खेत",
    selectFarm: "फार्म का चयन करें",
    searchFarm: "खोज फार्म",
    confirmation: "पुष्टीकरण",
    proceed: "आगे बढ़ना",
    ok: "ठीक",
    animal: {
      tagH: "उपनाम",
      tagNumberH: "टैग संख्या: आप रंग के साथ-साथ संख्या भी जोड़ सकते हैं। ",
      goveRegNoH: "पहचान विवरण जिसमें व्यक्ति का नाम और पता, प्रक्रिया की सेवा के लिए व्यक्ति का एजेंट, की जाने वाली गतिविधि का स्थान और व्यक्ति द्वारा प्रदान की जाने वाली सेवा का विवरण शामिल हो सकता है।",
      birthWeightH: "बछड़े का जन्म वजन",
      birthEaseH: "पशुधन में जन्म एक प्राकृतिक प्रक्रिया है लेकिन कभी-कभी ऐसी जन्म समस्याएं हो सकती हैं जहां बांध को किसान/पशुपालक से सहायता की आवश्यकता होती है।",
      birthFarmH: "जन्म फार्म जहां जानवर का जन्म हुआ",
      surrogateDamH: "यदि पशु भ्रूण स्थानांतरण के माध्यम से पैदा हुआ है। यह वाहक मां/एक मादा जानवर की आईडी है जो किसी अन्य जानवर के स्थान पर युवा होने के लिए गर्भधारण (भ्रूण स्थानांतरण या कृत्रिम गर्भाधान द्वारा) किया जाता है।",
      ownerH: "यह जानवर के मालिक का नाम है।",
      damH: "जानवर के बांध की आईडी या पंजीकरण संख्या - एक जानवर की मादा माता-पिता। ",
      sireH: "एक जानवर के नर माता-पिता की एक आईडी या पंजीकरण संख्या, विशेष रूप से प्रजनन के लिए रखे गए बैल या कृत्रिम गर्भाधान के लिए इस्तेमाल किए गए बैल के वीर्य।",
      breedH: "यह जानवर की एक नस्ल है।",
      conceptionMethodH: "जानवर की कल्पना कैसे की गई थी।",
      genderH: "जानवर का लिंग।",
      dobH: "जानवर के जन्म की तारीख।",
      operatorH: "इस जानवर की जानकारी भरने वाले व्यक्ति का नाम।",
      removalFarmH: "पशु हटाया खेत ",
      dateOfRemovalH: "पशु हटाने की तिथि",
      destinationOfRemoval: "हटाए गए जानवर का गंतव्य स्थान",
      reasonOfRemovalH: "जानवरों को हटाने का कारण",
      trackingNumberH: "जब जानवर को हटा दिया जाता है तो जानवर को नंबर दिया जाता है",
      brandH: "ब्रांड-बस एक स्थायी निशान जो गाय पर जलाया गया था।",
      tattoH: "जानवर पर टैटू।",
      hornStatusH: "क्या जानवर के सींग नहीं निकले हैं।",
      animalOriginH: "पशु की उत्पत्ति का देश।",
      previousOwnerH: "पशु के पिछले मालिक का नाम यदि वह परिपक्व है।",
      twinH: "यह क्षेत्र बताता है कि जानवर के जुड़वां हैं या नहीं।",
      regBreedAssoNoH: "नस्ल संघों/सोसायटियों के साथ पंजीकरण।",
      breedAssoNameH: "संघों/सोसायटियों के नाम जहां पशु पंजीकृत किया गया था",
      breederH: "यह उस संस्था का नाम है जिसने जानवर की आपूर्ति की थी।",
      breeder: "ब्रीडर",
      noteH: "जानवर के बारे में महत्वपूर्ण नोट।",
      accuracyWeight_for_field: "सटीकता वजन",
      conception: "धारणा",
      addAnAnimal: "एक जानवर जोड़ें",
      addAnimal: "पशु जोड़ें",
      registerAnAnimal: "एक पशु पंजीकृत करें",
      uploadAnAnimal: "एक जानवर अपलोड करें",
      animalRegistration: "पशु पंजीकरण",
      animalDetails: "पशु विवरण",
      tag: "उपनाम",
      tagNumber: "टैग संख्या",
      govtRegNumber: "सरकार। ",
      birthWeight: "जन्म के समय वजन",
      birthEase: "जन्म आसानी",
      birthFarm: "जन्म फार्म",
      surrogateDam: "सरोगेट बांध",
      owner: "मालिक",
      ownershipType: "स्वामित्व प्रकार",
      animalDiseaseRecord: "पशु रोग रिकॉर्ड",
      govtReg: "सरकार। ",
      regDate: "रेग दिनांक",
      dam: "बाँध",
      sire: "सर ई",
      heifer: "कलोर",
      steer: "रास्ते पर लाना",
      calf: "बछड़ा",
      farmHerd: "खेत / झुंड",
      femaleCalf: "मादा बछड़ा",
      maleCalf: "नर बछड़ा",
      newCalves: "नए बछड़े",
      breed: "नस्ल",
      conceptionMethod: "गर्भाधान विधि",
      gender: "लिंग",
      dateOfBirth: "जन्म की तारीख",
      operator: "ऑपरेटर",
      animalRemovedFarm: "पशु हटाया खेत",
      dateOfAnimalRemoval: "पशु हटाने की तिथि",
      destinationOfRemovedAnimal: "हटाए गए पशु का गंतव्य",
      reasonOfRemoval: "हटाने का कारण",
      optionalAnimalInformation: "वैकल्पिक पशु सूचना",
      animalPicture: "पशु चित्र",
      trackingNumber: "ट्रैकिंग नंबर",
      brand: "ब्रैंड",
      tatto: "टटू",
      hornStatus: "हॉर्न स्थिति",
      animalOrigin: "पशु उत्पत्ति",
      previosOwner: "पूर्व मालिक",
      twin: "जुड़वां",
      InABreedAssociation: "रेग।",
      nameOfBreedAssociations: "नस्ल संघों का नाम",
      breedAssociations: "नस्ल संघ",
      breederSupplier: "ब्रीडर (आपूर्तिकर्ता)",
      importAnimal: "पशु आयात करें",
      loadingAnimals: "जानवर लोड हो रहे हैं... कृपया प्रतीक्षा करें",
      totalRegAnimals: "कुल पंजीकरण। ",
      totalPregnantAnimals: "कुल गर्भवती पशु",
      pregnantAnimalHistory: "गर्भवती पशु इतिहास",
      dailyAnimalPregnancyUpdates: "दैनिक पशु गर्भावस्था अद्यतन",
      animalHistory: "पशु इतिहास",
      dailyAnimalUpdates: "दैनिक पशु अद्यतन",
      totalPregnant: "कुल गर्भवती",
      totalNewBorn: "कुल नवजात",
      searchByIDGOVRegTag: "आईडी, जीओवी रेग और टैग द्वारा खोजें",
      noANIMALAVAILABLE: "कोई जानवर उपलब्ध नहीं है",
      associationNumber: "संघ संख्या",
      associationName: "संघ का नाम",
      destinationName: "गंतव्य नाम",
      plastic: "प्लास्टिक",
      metal: "धातु",
      naturalMating: "प्राकृतिक संभोग",
      artificialInsemination: "कृत्रिम गर्भाधान",
      embryoTransfer: "भ्रूण स्थानांतरण",
      noAssistance: "कोई सहायता नहीं",
      someAssistance: "कुछ सहायता",
      mechanicalAssistance: "यांत्रिक सहायता",
      aCesareanSection: "एक सिजेरियन सेक्शन",
      abnormalDelivery: "असामान्य प्रसव",
      male: "नर",
      female: "महिला",
      sale: "बिक्री",
      slaughter: "वध",
      death: "मौत",
      theft: "चोरी",
      other: "अन्य",
      horned: "सींग वाला",
      polled: "सर्वेक्षण में शामिल",
      dehorned: "डीहॉर्नड",
      details: "विवरण",
      performance: "प्रदर्शन",
      geneticWorth: "आनुवंशिक मूल्य",
      healthRecord: "स्वास्थ्य रिकॉर्ड",
      genotypeData: "जीनोटाइप डेटा",
      reminders: "अनुस्मारक",
      activityLog: "गतिविधि लॉग",
      activityLogDetails: "गतिविधि लॉग विवरण",
      editAnimal: "पशु संपादित करें",
      familyInfo: "परिवार की जानकारी",
      breedInfo: "नस्ल की जानकारी",
      identification: "पहचान",
      removalInfo: "हटाने की जानकारी",
      iDOfAnimalDam: "जानवरों के बांध की आईडी।",
      iDOfAnimalSire: "जानवर के साहब की पहचान।",
      iDOfDamEmbryoUsed: "बांध की आईडी जिसका भ्रूण इस्तेमाल किया गया था।",
      animalHasATwinOrNot: "जानवर का जुड़वाँ है या नहीं।",
      breedType: "नस्ल का प्रकार",
      breedOfTheAnimal: "यह जानवर की एक नस्ल है।",
      regBreedAssociations: "नस्ल संघों/सोसायटियों के साथ पंजीकरण।",
      nameOfAssociationsSocieties: "संघों/सोसायटियों के नाम जहां पशु पंजीकृत किया गया था।",
      nameOfTheOrgSuppliedAnimal: "यह उस संस्था का नाम है जिसने जानवर की आपूर्ति की थी।",
      countryOriginAnimal: "पशु की उत्पत्ति का देश।",
      birthFarmID: "जन्म फार्म आईडी",
      farmIDAnimalBorn: "फार्म आईडी जहां पशु का जन्म हुआ था।",
      currentOwner: "वर्तमान मालिक",
      nameOfOwnerAnimal: "यह जानवर के मालिक का नाम है।",
      registrationDate: "पंजीकरण की तारीख",
      previousOwner: "पूर्व स्वामी",
      nameOfOperator: "ऑपरेटर का नाम",
      dateAnimalRemoved: "दिनांक जब जानवर को हटा दिया जाता है।",
      destinationPlaceRemovedAnimal: "हटाए गए जानवर के लिए गंतव्य स्थान",
      namePersonFillAnimalInformation: "इस जानवर की जानकारी भरने वाले व्यक्ति का नाम।",
      reasonOfAnimalRemoval: "जानवरों को हटाने का कारण",
      reasonWhyTheAnimalIsRemoved: "कारण क्यों जानवर को हटा दिया जाता है",
      processingDate: "प्रसंस्करण तारीख",
      DateInformationFilledChanged: "वह दिनांक जब वर्तमान जानकारी भरी या बदली गई थी।",
      animalID: "पशु आईडी",
      UniqueIdAnimal: "यह जानवर की अनूठी आईडी है।",
      plasticTagNumber: "प्लास्टिक टैग संख्या",
      numberAnimalTag: "पशु टैग की संख्या।",
      rFTagNumber: "आरएफ टैग संख्या",
      numberAnimalRFTag: "पशु आरएफ टैग की संख्या।",
      govtRegNumb: "सरकार। ",
      govtRegistrationNumber: "पहचान विवरण जिसमें व्यक्ति का नाम और पता, प्रक्रिया की सेवा के लिए व्यक्ति का एजेंट, की जाने वाली गतिविधि का स्थान और व्यक्ति द्वारा प्रदान की जाने वाली सेवा का विवरण शामिल हो सकता है।",
      numberAssignedAnimalIsRemoved: "ट्रैकिंग नंबर जानवरों की गतिविधि पर नज़र रखने के लिए उपयोग की जाने वाली जानवरों की आईडी में से एक है।",
      dateOfAnimalRegistration: "पशु पंजीकरण की तिथि",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "ब्रांड-बस एक स्थायी निशान जो गाय पर जलाया गया था।",
      tattoOnAnimal: "जानवर पर टैटू।",
      whetherTheAnimalIsDehorned: "क्या जानवर के सींग नहीं निकले हैं।",
      milkingAnimals: "दूध देने वाले जानवर",
      studAnimals: "स्टड एनिमल्स",
      animalInseminationRecord: "पशु गर्भाधान रिकॉर्ड",
      numOfStrawsOrdered: "ऑर्डर किए गए स्ट्रॉ की संख्या",
      totalNumOfStraws: "स्ट्रॉ की कुल संख्या",
      strawId: "स्ट्रॉ आईडी",
      addSireAutomation: "साहब स्वचालन जोड़ें",
      addApprovalAutomation: "स्वीकृति स्वचालन जोड़ें",
      addCollectionAutomation: "संग्रह स्वचालन जोड़ें",
      addStrawsAutomation: "स्ट्रॉ ऑटोमेशन जोड़ें",
      addPackAutomation: "पैक स्वचालन जोड़ें",
      addPostageAutomation: "डाक स्वचालन जोड़ें",
      searchBySire: "searchBySire",
      numberOfProgenies: "संतानों की संख्या",
      sireEdit: "साहब संपादित करें",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "स्ट्रॉ आईडी द्वारा खोजें, स्ट्रॉ की कुल संख्या, बैच संख्या और स्थान आईडी",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "पैक आईडी द्वारा खोजें, ऑर्डर किए गए स्ट्रॉ की संख्या, पैकिंग तकनीक",
      searchByCollectionAndPreparationTechnicia: "संग्रह और तैयारी तकनीक द्वारा खोजें",
      registerSemenAutomation: "वीर्य स्वचालन पंजीकृत करें",
      addSemenAutomation: "वीर्य स्वचालन जोड़ें",
      strawAutomationRegistered: "स्ट्रॉ ऑटोमेशन पंजीकृत",
      strawAutomationRegisteredNotRegistered: "स्ट्रॉ ऑटोमेशन पंजीकृत पंजीकृत नहीं",
      sireAutomationRegistered: "साहब स्वचालन पंजीकृत",
      sireAutomationNotRegistered: "साहब स्वचालन पंजीकृत नहीं है",
      postageAutomationIsRegistered: "डाक स्वचालन पंजीकृत है",
      postageAutomationNotRegistered: "डाक स्वचालन पंजीकृत नहीं है",
      packAutomationIsRegistered: "पैक स्वचालन पंजीकृत है",
      packAutomationNotRegistered: "पैक स्वचालन पंजीकृत नहीं है",
      postageAutomationIsUpdated: "डाक स्वचालन अद्यतन किया जाता है",
      postageAutomationNotUpdated: "डाक स्वचालन अद्यतन नहीं",
      packAutomationIsUpadted: "पैक स्वचालन अद्यतन किया गया है",
      packAutomationNotUpadted: "पैक स्वचालन अद्यतन नहीं किया गया",
      collectionAutomationUpdated: "संग्रह स्वचालन अद्यतन",
      collectionAutomationNotUpdated: "संग्रह स्वचालन अद्यतन नहीं",
      approvalAutomationIsUpdated: "स्वीकृति स्वचालन अद्यतन किया गया है",
      approvalAutomationIsNotUpdated: "स्वीकृति स्वचालन अद्यतन नहीं है",
      collectionAutomationRegistered: "संग्रह स्वचालन पंजीकृत",
      collectionAutomationNotRegistered: "संग्रह स्वचालन पंजीकृत नहीं है",
      approvalAutomationIsRegistered: "अनुमोदन स्वचालन पंजीकृत है",
      approvalAutomationIsNotRegistered: "अनुमोदन स्वचालन पंजीकृत नहीं है",
      strawAutomationUpdated: "स्ट्रॉ ऑटोमेशन अपडेट किया गया",
      strawAutomationIsNotUpdated: "स्ट्रॉ ऑटोमेशन अपडेट नहीं किया गया है",
      searchSire: "खोजो साहब",
      strawsEdit: "तिनके संपादित करें",
      nextAnimals: "अगला जानवर",
      performanceInfo: {
        milk: "दूध",
        liveweight: "जीवित वजन",
        score: "अंक",
        fertility: "उपजाऊपन",
        measurements: "मापन",
        dailyProteinYield: "दैनिक प्रोटीन उपज",
        amountProteinMilkCowDay: "विशेष दिन में गाय से प्राप्त दूध में प्रोटीन की मात्रा।",
        dailyMilkYield: "दैनिक दूध की उपज",
        volumeMilkCowDay: "एक विशेष दिन में एक विशेष गाय से प्राप्त दूध की मात्रा।",
        dailyFatYield: "दैनिक वसा उपज",
        amountFatMilkCowDay: "विशेष दिन में गाय से प्राप्त दूध में वसा की मात्रा।",
        dailyProteinContent: "दैनिक प्रोटीन सामग्री",
        dailyFatContent: "दैनिक वसा सामग्री",
        milkLactose: "दूध लैक्टोज",
        amountLactoseMilk: "दूध में लैक्टोज की मात्रा।",
        milkUrea: "दूध यूरिया",
        indicatorAmountCrudeProtein: "गाय के आहार में अपरिष्कृत प्रोटीन की मात्रा का संकेतक",
        lactationNumber: "स्तनपान संख्या",
        ordinalNumLactation: "दुद्ध निकालना की क्रमिक संख्या।",
        lengthOfLactation: "स्तनपान की अवधि (जैसे 23 दिन)",
        lactationLength: "स्तनपान की लंबाई",
        milkingFrequency: "दूध देने की आवृत्ति",
        frequcnyOfMilking: "दूध देने की आवृत्ति (उदाहरण के लिए 2 बार / दिन)",
        liveWeightInformation: "लाइववेट जानकारी",
        currentWeight: "वर्तमान वजन",
        weightAnimal: "जानवर का वजन।",
        postWeaningGain: "वीनिंग के बाद का लाभ",
        dailyGainInAnimalWeightWeaning: "दूध छुड़ाने के बाद पशु के वजन में दैनिक वृद्धि।",
        weaningWeight: "वजन कम करना",
        weightAnimalMeasuredWeaning: "दूध छुड़ाने के एक दिन में जानवर का वजन नापा जाता है।",
        averageDailyGain: "औसत दैनिक लाभ",
        averageAmountWeightAnimalGainFeedingPeriod: "भोजन की अवधि के दौरान प्रत्येक दिन एक जानवर का औसत वजन बढ़ेगा",
        carcassWeight: "लाश का वजन",
        weightAnimalsHideInternalOrgansRemoved: "सिर, खाल और आंतरिक अंगों के बाद जानवरों का वजन हटा दिया गया है।",
        weightAtCalving: "बछड़े के समय वजन",
        weightAtTheTimeOfCalving: "ब्याने के समय वजन।",
        yearlingWeight: "वार्षिक वजन",
        weightYearOldAnimal: "एक वर्ष के पशु का वजन।",
        somaticCellScore: "दैहिक कोशिका स्कोर",
        somaticCellScoreIndicatorMastitis: "मास्टिटिस के लिए एक संकेतक के रूप में दैहिक कोशिका स्कोर। ",
        lastUpdate: "आखिरी अपडेट",
        bodyConditionScore: "शरीर की स्थिति स्कोर",
        scoreAnimalFat: "उसमें कितनी चर्बी है, इस संबंध में पशु का स्कोर।  ",
        teatScore: "टीट स्कोर",
        scoreMeasureingShapeTeats: "टीट आकार के स्कोर टीट की लंबाई और परिधि के व्यक्तिपरक आकलन हैं और 9 (बहुत छोटे) से 1 (बहुत बड़े) तक हैं। ",
        udderScore: "थन निलंबन स्कोर",
        scoreMeasureingShapeOfUdder: "थन के आकार को मापने वाला स्कोर (1-9 स्कोर)। ",
        whetherAnimalEasyBirthDifficult: "पशुधन में जन्म एक प्राकृतिक प्रक्रिया है लेकिन कभी-कभी ऐसी जन्म समस्याएं हो सकती हैं जहां बांध को किसान/पशुपालक से सहायता की आवश्यकता होती है।",
        totalLongevity: "कुल दीर्घायु",
        survivalLactationTraitCowCulledBreeding: "पहली से पांचवीं स्तनपान तक उत्तरजीविता। ",
        docility: "अधीनता",
        circumferenceBullScrotal: "बैल के अंडकोश की परिधि",
        intervalSuccessInsemination: "पहले से सफल गर्भाधान तक का अंतराल।",
        ageAtFirstCalving: "प्रथम ब्याने के समय आयु",
        ageCowCalving: "गाय के पहले ब्याने की उम्र कितनी होती है।",
        calvingInterval: "कैल्विंग अंतराल",
        periodCalving: "एक ब्यांत से दूसरे ब्यांत तक की अवधि।",
        scrotalCircumference: "अंडकोश की परिधि",
        estrusDetection: "एस्ट्रस डिटेक्शन",
        trackingBehaviorAnimalDetectingEstrus: "एक गाय के एस्ट्रस का पता लगाने के लिए जानवर की गतिविधि पर नज़र रखना।",
        presenceOfEstrus: "एस्ट्रस की उपस्थिति",
        isCowInEstrusStage: "जब गाय एस्ट्रस स्टेज पर हो या न हो",
        matureWeight: "परिपक्व वजन",
        weightAnimalDefinedAge: "एक परिभाषित आयु में एक जानवर का वजन।",
        matureHeight: "परिपक्व ऊंचाई",
        heightAnimalDefinedAge: "परिभाषित आयु में एक जानवर की ऊंचाई।",
        footClawSet: "पैर पंजा सेट",
        shapeAnimalClaw: "जानवर के पंजे का आकार।",
        pulmonaryArterialPressure: "फुफ्फुसीय धमनी दबाव",
        animalBloodPreasure: "पशु का रक्त चाप।",
        footAngle: "फुट कोण",
        shapeAnimalFoot: "जानवर के पैर का आकार।",
        ribEyeArea: "रिब-आंख क्षेत्र",
        amountRibEyeArea: "रिब-आई क्षेत्र की मात्रा।",
        ultrasoundFat: "अल्ट्रासाउंड वसा",
        measureFatAmount: "वसा की मात्रा का माप।",
        ultrasoundIntramuscularFat: "अल्ट्रासाउंड इंट्रामस्क्युलर फैट",
        ultrasoundRibEyeArea: "अल्ट्रासाउंड रिब-आई क्षेत्र",
        measureRibeyeArea: "रिबे क्षेत्र का माप।",
        fatThickness: "वसा की मोटाई",
        anmountAnimalBackFat: "पशु की पीठ की चर्बी की मात्रा।",
        marbling: "marbling",
        marballingMeasurement: "मार्बलिंग दिखाई देने वाला असंतृप्त (स्वस्थ) इंट्रामस्क्युलर वसा है जो मांसपेशियों के भीतर और मांसपेशी फाइबर बंडलों के बीच जमा होता है।",
        dryMatterIntake: "शुष्क पदार्थ का सेवन",
        amountFeedAnimalConsumesAMoisture: "नमी रहित आधार पर एक पशु द्वारा प्रति दिन खाए जाने वाले भोजन की मात्रा।"
      },
      feedsName: "फ़ीड नाम",
      feedName: "फ़ीड नाम",
      firstFeedQuantity: "पहली फ़ीड मात्रा",
      additionalFeed: "अतिरिक्त फ़ीड",
      cloversRyeGrasses: "तिपतिया घास, राई घास",
      greenFodderHayLegumes: "हरा चारा, घास, फलियां",
      feedsRegisteredSuccessfully: "फ़ीड सफलतापूर्वक पंजीकृत",
      feedsNotRegistered: "फ़ीड पंजीकृत नहीं है",
      fEEDQUANTITY: "फ़ीड मात्रा",
      feedQuantity: "फ़ीड मात्रा",
      fEEDNAME: "फ़ीड नाम",
      nOFEEDINFOAVAILABLE: "कोई फ़ीड जानकारी उपलब्ध नहीं है",
      searchByFeedName: "फ़ीड नाम से खोजें",
      loadingFeedInfo: "फ़ीड जानकारी लोड हो रही है... कृपया प्रतीक्षा करें",
      todayFeedInfo: "आज फ़ीड जानकारी",
      feedInfo: "फ़ीड जानकारी",
      loremIpsumDolorSitAmet: "लोरेम इप्सम डोलर सिट एमेट, कॉन्सेक्टेटुर एडिपिसिंग एलीट। ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "क्या इस प्रजनन मूल्य का उपयोग आर्थिक सूचकांक की गणना के लिए किया जाता है।",
        dailyProteinYieldUsed: "डेली प्रोटीन यील्ड यूज्ड",
        weightAssignedBreedingDailyProteinYield: "वजन \"दैनिक प्रोटीन उपज\" के अनुरूप प्रजनन मूल्य को सौंपा गया है।" ,
        dailyProteinYieldWeight: "दैनिक प्रोटीन उपज वजन",
        rankAnimalInRelationshipEconomicIndex: "आर्थिक सूचकांक के संबंध में पशु की रैंक।",
        economicIndexRank: "आर्थिक सूचकांक रैंक",
        percentileEconomicIndexFall: "पर्सेंटाइल जो आर्थिक सूचकांक में आता है।",
        economicIndexPercentile: "आर्थिक सूचकांक प्रतिशतक",
        accuracyOfEconomicIndex: "आर्थिक सूचकांक की सटीकता।",
        economicIndexAccuracy: "आर्थिक सूचकांक सटीकता",
        weightedAverageOfBreedingValues: "प्रजनन मूल्यों का भारित औसत।",
        economicIndex: "आर्थिक सूचकांक",
        rankOfAnimalInRelationshipBreeding: "इसी प्रजनन मूल्य के संबंध में पशु की रैंक।",
        dailyProteinYieldBreedingValueRank: "दैनिक प्रोटीन उपज प्रजनन मूल्य रैंक ",
        percentileBreedingFalls: "पर्सेंटाइल जिसमें ब्रीडिंग वैल्यू आती है।",
        dailyProteinYieldBreedingPercentile: "दैनिक प्रोटीन उपज प्रजनन मूल्य प्रतिशतक ",
        accuracyEstimatedBreeding: "अनुमानित प्रजनन मूल्य की सटीकता।",
        dailyProteinYieldBreedingAccuracy: "दैनिक प्रोटीन उपज प्रजनन मूल्य सटीकता",
        estimatedBreedingTraitDailyProteinYield: "विशेषता का अनुमानित प्रजनन मूल्य \"दैनिक प्रोटीन उपज।",
        dailyProteinYieldBreedingValue: "दैनिक प्रोटीन उपज प्रजनन मूल्य ",
        pathToTheDirectoryScriptsBreeding: "हार्ड ड्राइव पर निर्देशिका का पथ जिसमें स्क्रिप्ट हैं जिसका उपयोग प्रजनन मूल्य की गणना के लिए किया गया था।",
        scriptsPath: "स्क्रिप्ट पथ",
        softwarePackageBreeding: "सॉफ्टवेयर पैकेज जिसका उपयोग प्रजनन मूल्य की गणना के लिए किया गया था।",
        breedingValueSoftware: "प्रजनन मूल्य सॉफ्टवेयर",
        methodCalculateBreeding: "प्रजनन की गणना के लिए जिस विधि का उपयोग किया गया था",
        breedingValueMethod: "प्रजनन मूल्य विधि",
        trait: "प्रवृत्ति",
        tools: "औजार",
        geneticWorth: "आनुवंशिक मूल्य",
        dailyProteinYield: "दैनिक प्रोटीन उपज",
        breedingValue: "प्रजनन मूल्य",
        breedingValueBIFAccuracy: "प्रजनन मूल्य बीआईएफ सटीकता",
        breedingValuePercentile: "प्रजनन मूल्य प्रतिशतक",
        breedingValueRank: "ब्रीडिंग वैल्यू रैंक",
        checkLTD: "लिमिटेड की जाँच करें",
        ultrasoundDiagnostic: "अल्ट्रासाउंड डायग्नोस्टिक",
        selectYieldUsed: "प्रयुक्त यील्ड का चयन करें",
        softwareName: "सॉफ्टवेयर का नाम",
        animalGenWorthUpdatedSuccessfully: "एनिमल जेन वर्थ सफलतापूर्वक अपडेट किया गया"
      },
      addNote: "नोट जोड़े",
      enterNote: "नोट दर्ज करें",
      noteIsRequired: "नोट आवश्यक है",
      noteMustBeLessThan50Characters: "नोट 50 वर्णों से कम का होना चाहिए",
      noteAdded: "नोट जोड़ा गया",
      noteNotAdded: "नोट नहीं जोड़ा गया",
      noteForAnimal: "जानवर के लिए नोट।",
      noNoteFoundForThisAnimal: "इस जानवर के लिए कोई नोट नहीं मिला।",
      inseminationData: "गर्भाधान डेटा",
      nameOfInseminator: "बीजक का नाम",
      activity: "गतिविधि",
      searchByNameActivity: "नाम, गतिविधि द्वारा खोजें",
      searchByTaskNameNumber: "कार्य नाम, संख्या द्वारा खोजें",
      inseminationDate: "गर्भाधान तिथि",
      genotypeDataInfo: {
        genotypeAnimalID: "जीनोटाइप एनिमल आईडी",
        iDTubeBloodSampleAnimalNumberGenotypingService: "यह एक ट्यूब की आईडी है जिसमें जानवर से लिया गया रक्त का नमूना या कई जीनोटाइपिंग सेवा है",
        geneticTechnicianName: "आनुवंशिक तकनीशियन का नाम",
        NameTechnicianBloodSamplesAnimal: "यह उस टेक्नीशियन का नाम है जिसने जानवर के खून के नमूने लिए थे",
        sNPData: "एसएनपी डेटा",
        genotypingServiceNote: "जीनोटाइपिंग सेवा नोट",
        InfoGenotypingGenotypingTechnology: "जीनोटाइपिंग से संबंधित सभी जानकारी जैसे जीनोटाइपिंग कंपनी का नाम, इस्तेमाल की गई जीनोटाइपिंग तकनीक, जीनोटाइपिंग की तारीख आदि।",
        numberOfSNPs: "एसएनपी की संख्या",
        numberOfSNPsAnimalGenotyped: "एसएनपी की संख्या जिसके लिए जानवर को जीनोटाइप किया गया था",
        nameOfTheDrug: "दवा का नाम",
        animalGenoDataUpdatedSuccessfully: "एनिमल जेनो डेटा सफलतापूर्वक अपडेट किया गया",
        animalGenoDataNotUpdated: "एनिमल जेनो डेटा अपडेट नहीं",
        animalIDIsRequired: "पशु आईडी आवश्यक है",
        techNameIsRequired: "टेक। ",
        onlyAlphabetsAreAllowed: "केवल अक्षरों की अनुमति है",
        genoDataIsRequired: "जेनो डेटा आवश्यक है",
        serviceNoteIsRequired: "सेवा नोट आवश्यक है",
        sNPIsRequired: "एसएनपी आवश्यक है"
      },
      healthRecordInfo: {
        treatment: "इलाज",
        treatmentTakenAnimal: "जानवर पर क्या उपचार किया गया।",
        reasonOfTreatment: "उपचार का कारण",
        reasonForTreatment: "उपचार का कारण",
        whatReasonOfTreatment: "उपचार का कारण क्या है।",
        treatmentDate: "इलाज की तारीख",
        dateOfTreatment: "उपचार की तिथि।",
        diagnosis: "निदान",
        nameDiagnosedDiseaseConditionSymptoms: "निदान की गई बीमारी/स्थिति या मुख्य लक्षण का नाम",
        drugID: "ड्रग आईडी",
        iDOfDrugWhichIsGivenToAnimal: "जानवर को दी जाने वाली दवा की आईडी।",
        drugName: "दवा का नाम",
        nameDrugAnimal: "पशुओं को दी जाने वाली औषधि का नाम ।",
        drugWithdrawalPeriod: "दवा निकासी अवधि",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "मानव उपभोग के लिए मांस या दूध की सुरक्षा सुनिश्चित करने के लिए किसी जानवर को दवा देने के बाद आवश्यक समय",
        attendingVeterinarian: "उपस्थित पशु चिकित्सक",
        qualifiedPersonCaseAnimal: "योग्य व्यक्ति जिसने केस/जानवर देखा",
        packID: "पैक आईडी",
        iDPackTreatment: "एक पैक की आईडी जिसका इलाज के लिए इस्तेमाल किया गया था",
        veterinarianName: "पशु चिकित्सक का नाम",
        animalNoHealthRecord: "इस जानवर का कोई स्वास्थ्य रिकॉर्ड नहीं है। ",
        addHealthRecord: "स्वास्थ्य रिकॉर्ड जोड़ें",
        healthStatus: "स्वास्थ्य की स्थिति",
        loadingDiseasesPleaseWait: "रोग लोड हो रहे हैं... कृपया प्रतीक्षा करें",
        animalDiseaseRecord: "पशु रोग रिकॉर्ड",
        animalHealthRecord: "पशु स्वास्थ्य रिकॉर्ड",
        animalTreatmentRecord: "पशु उपचार रिकॉर्ड",
        loadingHealthData: "स्वास्थ्य डेटा लोड हो रहा है...",
        healthRecord: "स्वास्थ्य रिकॉर्ड",
        nameOfDiagnosis: "निदान का नाम",
        treatmentName: "उपचार का नाम",
        drugGivenBy: "द्वारा दी गई दवा",
        recessiveDiseases: "रिसेसिव रोग",
        recessiveDiseasesMessage: "यह बैल किस आवर्ती रोग का वाहक है"
      },
      conceptionInfo: {
        addNewConception: "नई धारणा जोड़ें",
        semenEmbryo: "वीर्य/भ्रूण",
        pregnancyCheck: "गर्भावस्था की जाँच",
        birthInfo: "जन्म की जानकारी",
        searchByInseminatorOrganisationBreedingConception: "इंसेमिनेटर नाम, संगठन का नाम, ब्रीडिंग सर्विस नंबर, गर्भाधान विधि द्वारा खोजें",
        deliveryDate: "डिलीवरी की तारीख",
        calfId: "बछड़ा आईडी",
        birthDayOldWeight: "जन्म (दिन पुराना) वजन",
        searchByBirthEase: "जन्म आसानी से खोजें",
        searchPregnancyCheckOperatorMethod: "गर्भावस्था जांच ऑपरेटर द्वारा खोजें, गर्भावस्था जांच विधि",
        pregnancyCheckDate: "गर्भावस्था की जाँच की तारीख",
        conceptionSuccess: "गर्भाधान सफलता",
        pregnancyCheckOperator: "गर्भावस्था जांच ऑपरेटर",
        pregnancyCheckMethod: "गर्भावस्था जांच विधि",
        recentlyPregnant: "हाल ही में गर्भवती",
        pregnancyConfirmationDate: "गर्भावस्था की पुष्टि तिथि",
        pregnancyRate: "गर्भावस्था दर",
        timePeriodOfPregnancy: "गर्भावस्था की समय अवधि",
        semenProduction: "वीर्य उत्पादन",
        embryoProduction: "भ्रूण उत्पादन",
        semen: "वीर्य",
        embryoTransferDate: "भ्रूण स्थानांतरण तिथि",
        daysOfPregnancy: "गर्भावस्था के दिन",
        searchSireEmbryoSurrogate: "साइर आईडी, भ्रूण संगठन नाम, सरोगेट डैम नस्ल द्वारा खोजें",
        selectDate: "तारीख़ चुनें",
        orgnisationNameContainNumber: "संगठन के नाम में संख्या नहीं होनी चाहिए",
        selectBirthEase: "जन्म आसानी का चयन करें",
        selectUnit: "कृपया एक इकाई का चयन करें",
        animalConceptionAddedSuccessfully: "पशु गर्भाधान सफलतापूर्वक जोड़ा गया",
        postageCustomerName: "डाक ग्राहक का नाम",
        searchByPostageCustNameCustAddPostId: "डाक ग्राहक का नाम, ग्राहक का पता, डाक आईडी द्वारा खोजें",
        dateOfSemenCollection: "वीर्य संग्रह की तिथि",
        dateOfSemenPreparation: "वीर्य तैयार करने की तिथि",
        semenMotility: "वीर्य गतिशीलता",
        semenConcentration: "वीर्य एकाग्रता",
        postageEdit: "डाक खर्च संपादित करें",
        enterSireId: "साहब आईडी दर्ज करें",
        selectEmbryoOrganisation: "भ्रूण संगठन का चयन करें",
        matingDateH: "गर्भाधान की तिथि, या तो प्राकृतिक संभोग या कृत्रिम गर्भाधान।",
        inseminatorNameH: "एक व्यक्ति जो गर्भाधान प्रक्रिया करता है (पशु चिकित्सक/तकनीशियन)",
        orgNameH: "उस संगठन या कंपनी का नाम जो एआई के लिए सीमन स्ट्रॉ प्रदान करता है",
        brServiceNumH: "प्रजनन की संख्या रिकॉर्ड करना (उदाहरण के लिए पहली, दूसरी या तीसरी)",
        conceptionMethodH: "जिस तरह से जानवर ने गर्भ धारण किया वह गर्भावस्था की शुरुआत है, एक शुक्राणु द्वारा अंडे के निषेचन द्वारा चिह्नित।",
        sireIdH: "एक जानवर के नर माता-पिता की एक आईडी या पंजीकरण संख्या, विशेष रूप से प्रजनन के लिए रखे गए बैल या कृत्रिम गर्भाधान के लिए इस्तेमाल किए गए बैल के वीर्य।",
        damIdH: "जानवर के बांध की आईडी या पंजीकरण संख्या - एक जानवर की मादा माता-पिता। ",
        sarogatedDamH: "यदि पशु भ्रूण स्थानांतरण के माध्यम से पैदा हुआ है। यह वाहक मां/एक मादा जानवर की आईडी है जो किसी अन्य जानवर के स्थान पर युवा होने के लिए गर्भधारण (भ्रूण स्थानांतरण या कृत्रिम गर्भाधान द्वारा) किया जाता है।",
        embOrgNameH: "भ्रूण के लिए संगठन का नाम",
        sarogateDamBreedH: "सरोगेट नस्ल की तारीख",
        sireBreedH: "सायर नस्ल का प्रकार (ब्राह्मण, बोरान)",
        pregCheckDateH: "अल्ट्रासाउंड और रक्त परीक्षण का उपयोग करके 30 दिनों के भीतर गायों में गर्भावस्था का पता लगाया जा सकता है। गायों को पैल्पेशन पद्धति का उपयोग करके गर्भवती के रूप में पहचाने जाने के लिए, गायों को अक्सर कम से कम 35-50 दिनों की गर्भवती होने की आवश्यकता होती है। ",
        conceptionSuccessH: " मवेशियों में, निषेचन दर लगभग 55% की औसत बछड़े की दर के साथ 90% है, जो लगभग 35% भ्रूण-भ्रूण मृत्यु दर का संकेत देता है (डिस्किन एट अल।, 2006)। ",
        pregnancyCheckOperatorH: "पशु चिकित्सक और विशेषज्ञ पशु तकनीशियन आमतौर पर किसानों को ये सेवाएं प्रदान करते हैं। ",
        pregnancyCheckMethodH: "मवेशियों के गर्भावस्था के निदान के लिए दो सबसे अधिक इस्तेमाल की जाने वाली विधियाँ प्रजनन पथ (प्रति मलाशय) का मैनुअल पैल्पेशन और प्रजनन पथ का ट्रांसरेक्टल अल्ट्रासोनोग्राफी हैं।",
        deliveryDateH: "वह तारीख जब प्रसव हुआ हो",
        calfIdH: "नवजात बछड़े का पहचान पत्र",
        birthEaseH: "पशुधन में जन्म एक प्राकृतिक प्रक्रिया है लेकिन कभी-कभी ऐसी जन्म समस्याएं हो सकती हैं जहां बांध को किसान/पशुपालक से सहायता की आवश्यकता होती है।",
        birthDayOldWeightH: "जन्म के दिन किसी जानवर का वजन या एक दिन के पक्षी का वजन",
        customerAddress: "ग्राहक का पता"
      },
      all: "सभी",
      ungrouped: "असमूहीकृत पशु",
      active: "समूहीकृत पशु",
      updateAnimal: "अपडेट एनिमल"
    },
    dashboardS: {
      dailyActivities: "दैनिक गतिविधियां",
      pendingTasks: "लंबित कार्य",
      performanceOfGeno: "जीनोटाइप का प्रदर्शन",
      breed: "नस्ल",
      chromosome: "क्रोमोसाम",
      seqChange: "अनुक्रम परिवर्तन",
      inheritance: "विरासत",
      diseaseName: "रोग का नाम",
      refSequence: "संदर्भ अनुक्रम",
      pubmedRef: "प्रकाशित संदर्भ",
      matingDate: "मिलन तिथि",
      inseminatorName: "बीजक का नाम",
      orgName: "संगठन का नाम",
      brServiceNum: "प्रजनन सेवा संख्या",
      conceptionMethod: "गर्भाधान विधि",
      semEmbInfo: "वीर्य/भ्रूण की जानकारी",
      sireId: "साहब आईडी",
      damID: "डैम आईडी",
      srgDamId: "सरोगेट बांध आईडी",
      embOrgName: "भ्रूण संगठन। ",
      srgDamBreed: "सरोगेट बांध नस्ल",
      sireBreed: "सायर नस्ल",
      damBreed: "बांध नस्ल"
    },
    user: {
      selectLanguage: "भाषा चुने",
      unitPreference: "इकाई वरीयता",
      selectUnitOfMeasure: "माप की इकाई का चयन करें",
      importedUser: "आयातित उपयोगकर्ता",
      impFileStatus: "फ़ाइल स्थिति आयात करें",
      loadingUser: "उपयोगकर्ता लोड हो रहे हैं... कृपया प्रतीक्षा करें",
      totalUsers: "कुल उपयोगकर्ता",
      pendingUsers: "लंबित उपयोगकर्ता",
      changePassword: "पासवर्ड बदलें",
      goodIdeaToUsePassword: "एक मजबूत पासवर्ड का उपयोग करना एक अच्छा विचार है जिसे आप कहीं और उपयोग नहीं कर रहे हैं।",
      enterCurrentPassword: "वर्तमान पासवर्ड दर्ज करें",
      enterNewPassword: "नया पासवर्ड दर्ज करें",
      reEnterPassword: "नया पासवर्ड पुनः दर्ज करें",
      enterPassword: "पास वर्ड दर्ज करें",
      repeatNewPassword: "नया पासवर्ड दोहराएँ",
      emailAddr: "मेल पता",
      enterYourPhoneNumber: "अपना फोन नंबर डालें",
      pleaseTypeOldPassword: "कृपया पुराना पासवर्ड टाइप करें।",
      pleaseTypeNewPassword: "कृपया नया पासवर्ड टाइप करें।",
      pleaseTypeConfirmPassword: "कृपया पासवर्ड की पुष्टि करें टाइप करें।",
      passwordChangedSuccesFully: "पासवर्ड सफलतापूर्वक बदला गया",
      currentPassword: "वर्तमान पासवर्ड",
      newPassword: "नया पासवर्ड",
      passwordDoesNotMatch: "पासवर्ड मेल नहीं खाते।",
      emailCanNotBeEmpty: "ईमेल खाली नहीं हो सकता",
      profileUpdated: "प्रोफाइल अद्यतन किया गया",
      profileNotUpdated: "प्रोफाइल अपडेट नहीं है",
      unableToVerifyEmail: "ईमेल सत्यापित करने में असमर्थ",
      otpSentOnEmail: "ईमेल पर ओटीपी भेजा गया",
      otpSentSuccessFully: "ओटीपी सफलतापूर्वक भेजा गया",
      importUsers: "उपयोगकर्ता आयात करें",
      imageUpdated: "छवि अद्यतन",
      departmentName: "विभाग का नाम",
      departmentNum: "विभाग संख्या",
      departmentAdded: "विभाग जोड़ा गया",
      departmentNotAdded: "विभाग नहीं जोड़ा गया",
      searchDepartnment: "विभाग का नाम या संख्या द्वारा खोजें",
      addDepartMent: "विभाग जोड़ें",
      addDepartment: "विभाग जोड़ें",
      roleNameIsRequired: "भूमिका का नाम आवश्यक है",
      roleNameMustBeLessThan15Chars: "भूमिका का नाम 15 वर्णों से कम का होना चाहिए",
      roleAdded: "भूमिका जोड़ी गई",
      editDepartment: "विभाग संपादित करें",
      departmentUpdated: "विभाग अद्यतन",
      departmentNotUpdated: "विभाग अद्यतन नहीं",
      deleteDepartment: "विभाग हटाएं",
      deleteDepartmentMessage: "क्या आप वाकई इस विभाग को हटाना चाहते हैं।",
      noRoleAvailable: "कोई भूमिका उपलब्ध नहीं है",
      roleUpdated: "भूमिका अपडेट की गई",
      roleNotUpdated: "भूमिका अपडेट नहीं की गई",
      editRole: "भूमिका संपादित करें",
      allRole: "सभी भूमिका",
      addNewRole: "नई भूमिका जोड़ें",
      allDepartment: "समस्त विभाग",
      permissionsUpdated: "अनुमतियां अपडेट की गईं",
      permissionsnotUpdated: "अनुमतियां अपडेट नहीं की गईं",
      roleNo: "भूमिका संख्या",
      searchByEmailAndName: "ईमेल और नाम से खोजें",
      userID: "उपयोगकर्ता पहचान",
      userUpdated: "उपयोगकर्ता अपडेट किया गया",
      userNotUpdated: "उपयोगकर्ता अद्यतित नहीं है",
      userAdded: "उपयोगकर्ता जोड़ा गया",
      userNotAdded: "उपयोगकर्ता नहीं जोड़ा गया",
      activateUser: "उपयोगकर्ता को सक्रिय करें",
      deactivateUser: "उपयोगकर्ता को निष्क्रिय करें",
      userStatusMsg: "क्या आप वाकई उपयोगकर्ता स्थिति बदलना चाहते हैं",
      countryRequired: "देश आवश्यक है",
      stateRequired: "राज्य आवश्यक है",
      cityRequired: "नगर आवश्यक है",
      searchByRole: "भूमिका संख्या, भूमिका का नाम, विभाग द्वारा खोजें",
      noModuleAvailable: "कोई मॉड्यूल उपलब्ध नहीं है",
      searchBYModuleName: "मॉड्यूल नाम से खोजें"
    },
    farm: {
      farmID: "फार्म आईडी",
      onTheFarm: "खेत पर",
      userRoles: "उपयोगकर्ता भूमिका",
      adduser: "उपयोगकर्ता जोड़ें",
      addAuser: "एक उपयोगकर्ता जोड़ें",
      uploadUsers: "उपयोगकर्ता अपलोड करें",
      addNewUser: "नई उपयोगकर्ता को जोड़ना",
      selectDept: "विभाग का चयन करें",
      selectRole: "भूमिका का चयन करें",
      editUser: "यूजर को संपादित करो",
      totalFarms: "कुल खेत",
      NoAnimalsRegisteredForthisFarm: "इस फार्म के लिए कोई पशु पंजीकृत नहीं है",
      farmsPerPage: "प्रति पृष्ठ खेत",
      regularFarms: "नियमित खेत",
      farmRegisteredProducts: "फार्म पंजीकृत उत्पाद",
      searchByFarmNameAndId: "फार्म के नाम और आईडी द्वारा खोजें",
      loadingProductsPleaseWait: "उत्पाद लोड हो रहे हैं... कृपया प्रतीक्षा करें",
      farmName: "खेत का नाम",
      farmLocation: "खेत का स्थान",
      productName: "प्रोडक्ट का नाम",
      stockStatus: "स्टॉक की अवस्था",
      inStock: "स्टॉक में",
      searchByProductName: "उत्पाद के नाम से खोजें",
      productCategory: "उत्पाद श्रेणी",
      products: "उत्पादों",
      farms: "फार्म",
      registerAfarm: "एक फार्म पंजीकृत करें",
      govtRegistry: "सरकार। ",
      cooperativeID: "सहकारी आईडी",
      farmType: "खेत का प्रकार",
      contractMating: "अनुबंध संभोग",
      customization: "अनुकूलन",
      recordsPerpage: "प्रति पृष्ठ अभिलेखॉ",
      restoreDefault: "डिफ़ॉल्ट बहाल",
      apply: "आवेदन करना",
      searchState: "फार्म आईडी, सरकार रजिस्ट्री, सहकारी आईडी, फार्म प्रकार, अनुबंध संभोग द्वारा खोजें",
      farmOwner: "खेत मालिक",
      govRegistrationNo: "सरकारी पंजीकरण संख्या",
      farmInformation: "खेत की जानकारी",
      ownershipType: "स्वामित्व प्रकार",
      communityName: "समुदाय का नाम",
      farmLicenseInformation: "फार्म लाइसेंस की जानकारी",
      licenseNumber: "लाइसेंस संख्या",
      licenseExpiryDate: "लाइसेंस की समाप्ति तिथि",
      regulatorName: "नियामक का नाम",
      regulatorRepresentativeName: "नियामक प्रतिनिधि का नाम",
      farmLocationSize: "खेत का स्थान",
      productionSystem: "उत्पादन प्रणाली",
      country: "देश",
      state: "राज्य",
      city: "शहर",
      street: "गली",
      houseNumber: "घर का नंबर",
      farmRegistration: "फार्म पंजीकरण",
      cancel: "रद्द करना",
      register: "पंजीकरण करवाना",
      ok: "ठीक",
      totalFarmSize: "कुल खेत का आकार",
      farmGeographicLocation: "फार्म भौगोलिक स्थान",
      perimeterPointLongitude: "परिधि बिंदु देशांतर",
      perimeterPointLatitude: "परिधि बिंदु अक्षांश",
      perimeterPointLabel: "परिधि बिंदु लेबल",
      perimeterLength: "परिधि लंबाई",
      farmLatitude: "खेत अक्षांश",
      farmLongitude: "खेत देशांतर",
      editFarm: "फार्म संपादित करें",
      update: "अद्यतन",
      editAfarm: "एक खेत संपादित करें",
      nextFarm: "अगला खेत",
      nameoftheFarm: "फार्म का नाम",
      registerAProduct: " एक उत्पाद पंजीकृत करें",
      farmProducts: "कृषि उत्पाद",
      calf: "बछड़ा",
      steer: "रास्ते पर लाना",
      heifer: "कलोर",
      sire: "सर ई",
      dam: "बाँध",
      registerAnAnimal: "एक पशु पंजीकृत करें",
      farmAnimals: "खेत के जानवर",
      farm_type: "फार्म प्रकार",
      farm_Owner: "खेत-मालिक",
      dateOfRegistration: "पंजीकरण की तिथि",
      dataIsNotAvailableForThisFarm: "इस फार्म के लिए डेटा उपलब्ध नहीं है",
      registerNewProduct: "एक नया उत्पाद पंजीकृत करें",
      information: "जानकारी",
      licenseInfo: "लाइसेंस की जानकारी",
      locationInfo: "स्थान की जानकारी",
      geoLocation: "भू स्थान",
      perimeterLengthState: "खेतों की लंबाई परिधि (बाड़ की लंबाई)",
      totalFarmSizeState: "एक खेत का आकार",
      productionSystemState: "फार्म में प्रयुक्त उत्पादन प्रणाली",
      contractMatingState: "कोड ऑफ कॉन्ट्रैक्ट मेटिंग प्रोग्राम जिसमें फार्म भाग लेते हैं।",
      ownershipTypeState: "स्वामित्व के प्रकार",
      regulatorRepresentativeNameState: "लाइसेंस जारी करने वाले नियामक का प्रतिनिधित्व करने वाले व्यक्ति का नाम",
      regulatorNameState: "लाइसेंस जारी करने वाले नियामक का नाम",
      licenseExpiryDateState: "दिनांक जब वर्तमान लाइसेंस समाप्त हो गया है",
      licenseNumberState: "नियामक द्वारा जारी लाइसेंस संख्या",
      plotNumberState: "खेत का मकान नंबर।",
      plotNumber: "मकान/प्लॉट संख्या",
      streetStatement: "खेत का गली का नाम।",
      cityStatement: "शहर जहां खेत स्थित है।",
      stateStatement: "देश का क्षेत्र जहां खेत स्थित है।",
      countryState: "देश जहां खेत स्थित है।",
      perimeterPointLongitudeState: "खेत पर एक बिंदु का देशांतर।",
      perimeterPointLatitudeState: "खेत पर एक बिंदु का अक्षांश।",
      perimeterPointLabelState: "बिंदु का लेबल।",
      farmLongitudeState: "खेत का देशांतर।",
      farmLatitudeState: "खेत का अक्षांश।",
      farmNameH: "खेत का नाम",
      farmTypeH: "खेत का प्रकार जहाँ विभिन्न गतिविधियाँ की जाती हैं।",
      farmOwnerH: "एक खेत के मालिक का नाम (जानकारी दर्ज करने वाले किसान का नाम स्वत: उत्पन्न)",
      ownershipTypeH: "किसानों के प्रकार जो उस भूमि के मालिक हैं/नियंत्रित हैं जिस पर वे खेती करते हैं और जो नहीं करते हैं।",
      govtRegNumbH: "खेत की रजिस्ट्री संख्या जो नियामक द्वारा सौंपी गई थी",
      contractMatingH: "अनुबंध संभोग कार्यक्रम का कोड जिसमें फार्म भाग लेता है",
      productionSystemH: "खेत पर किस उत्पादन प्रणाली का उपयोग किया जाता है",
      cooperativeIDH: "एक सहकारी की आईडी जिसका खेत सदस्य है ",
      licenseNumberH: "नियामक द्वारा जारी लाइसेंस पर पहचान संख्या जो इसे मालिक के साथ पहचानती है।",
      licenseExpiryDateH: "दिनांक जब वर्तमान लाइसेंस समाप्त हो गया है",
      regularNameH: "लाइसेंस जारी करने वाले नियामक का नाम",
      regularRepName: "लाइसेंस जारी करने वाले नियामक का प्रतिनिधित्व करने वाले व्यक्ति का नाम",
      countryH: "देश जहां खेत स्थित है।",
      stateH: "देश का क्षेत्र जहां खेत स्थित है।",
      cityH: "शहर जहां खेत स्थित है।",
      streetH: "खेत का गली का नाम।",
      houseNumberH: "खेत का मकान नंबर।",
      totalFarmSizeH: "खेत का आकार उस भूमि का योग है जो वर्तमान में खेत द्वारा खेती की जाती है, जिसमें परती भूमि शामिल है, लेकिन प्राकृतिक वनस्पति, पेड़ या चरागाह के तहत भूमि शामिल नहीं है।",
      farmLatitudeH: "भूमध्य रेखा के उत्तर या दक्षिण की दूरी का माप है। ",
      farmLongitudeH: "यह प्रमुख याम्योत्तर के पूर्व या पश्चिम की दूरी को मापता है।",
      perimeterLengthH: "खेतों की परिधि की लंबाई (बाड़ की लंबाई)",
      perimeterPointLabelH: "बिंदु का लेबल। ",
      perimeterPointLatH: "खेत पर एक बिंदु का अक्षांश",
      perimeterPointLongH: "खेत पर एक बिंदु का देशांतर",
      noProductAvailable: "कोई उत्पाद उपलब्ध नहीं है",
      farmUpdated: "फार्म अपडेट किया गया",
      performance: "प्रदर्शन",
      milkInformation: "दूध की जानकारी",
      farmNameRequired: "खेत का नाम आवश्यक है"
    },
    login: {
      welcome: "स्वागत! ",
      welInfo: "अपनी साख दर्ज करें।",
      login: "लॉग इन करें",
      forgotPassword: "पासवर्ड भूल गए",
      forgotPasswordDesc: "कृपया अपने खाते से संबद्ध ईमेल पता दर्ज करें। ",
      backToLogin: "लॉगिन पर वापस जाएं"
    },
    actionListmod: {
      actionList: "कार्रवाई की सूची",
      tODAY: "आज",
      createTask: "कार्य बनाएँ",
      myActivities: "मेरी गतिविधियां",
      jhonSmith: "जॉन स्मिथ",
      farmID: "फार्म आईडी",
      dateOfEvent: "आयोजन की तिथि",
      actionRequired: "कार्रवाई आवश्यक है",
      actionTaken: "कार्रवाई की",
      animalEventID: "एनिमल इवेंट आईडी",
      cANCEL: "रद्द करना",
      cONFIRM: "पुष्टि करना",
      sTATEMENT: "क्या आप वाकई इस रिकॉर्ड को मिटाना चाहते हैं?",
      dAY: "दिन",
      wEEK: "सप्ताह",
      mONTH: "महीना",
      sUBMIT: "जमा करना",
      startDate: "आरंभ करने की तिथि",
      endDate: "अंतिम तिथि",
      rEPEAT: "दोहराना",
      taskCategory: "कार्य श्रेणी",
      pRIORITY: "प्राथमिकता",
      aSSIGNEE: "संपत्ति-भागी",
      selectLocation: "स्थान चुनें",
      selectAnimals: "एक या अधिक जानवरों का चयन करें",
      dESCRIPTION: "विवरण",
      customRecurrence: "कस्टम पुनरावृत्ति",
      repeatEvery: "हर बार दोहराएं",
      taskName: "कार्य का नाम",
      enterDescription: "विवरण दर्ज करें",
      toDo: "ऐसा करने के लिए",
      assignTo: "के लिए आवंटित",
      status: "दर्जा",
      nOTE: "टिप्पणी",
      noTaskAvailable: "कोई कार्य उपलब्ध नहीं है",
      healthRecord: "स्वास्थ्य रिकॉर्ड",
      iD: "पहचान",
      tAG: "उपनाम",
      dateOfbirth: "जन्म की तारीख",
      taskTakenat: "टास्क पर लिया गया",
      gENDER: "लिंग",
      bREED: "नस्ल",
      regDate: "रेग। ",
      updateHealthRecord: "जानवरों के लिए स्वास्थ्य रिकॉर्ड अपडेट करें",
      treatment: "इलाज",
      reasonOftreatment: "उपचार का कारण",
      treatmentDate: "इलाज की तारीख",
      dIAGNOSIS: "निदान",
      drugId: "ड्रग आईडी",
      drugName: "दवा का नाम",
      drugWithdrawalperiod: "दवा निकासी अवधि",
      attendingVeterinarian: "उपस्थित पशु चिकित्सक",
      packId: "पैक आई.डी",
      noItemsselected: "कोई आइटम नहीं चुना गया",
      healthRecordsubmission: "स्वास्थ्य रिकॉर्ड सबमिशन",
      inseminationRecordsubmission: "गर्भाधान-रिकॉर्ड सबमिशन",
      inseminatorName: "बीजक का नाम",
      inseminatorId: "सेमिनेटर आई.डी",
      conceptionRate: "गर्भाधान दर",
      dateOfmeasurement: "माप की तिथि",
      recordSubmission: "रिकॉर्ड सबमिशन",
      uPDATE: "अद्यतन",
      updateTask: "अद्यतन कार्य"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "इंसेमिनेटर जानकारी जोड़ें",
      inseminatorNumber: "सेमिनेटर संख्या",
      loadingInseminatorPleaseWait: "इंसेमिनेटर लोड हो रहा है... कृपया प्रतीक्षा करें",
      searchByIDAndName: "आईडी और नाम से खोजें",
      inseminatorInfoAdded: "इनसेमिनेटर जानकारी जोड़ी गई",
      inseminatorInfoNotAdded: "इंसेमिनेटर जानकारी नहीं जोड़ी गई",
      inseminatorInfoUpdated: "इंसेमिनेटर जानकारी अपडेट की गई",
      inseminatorInfoNotUpdated: "इंसेमिनेटर जानकारी अपडेट नहीं की गई",
      editAInseminatorInfo: "इंसेमिनेटर जानकारी संपादित करें",
      inseminatorList: "इनसेमिनेटर सूची",
      inseminatorInfoDetails: "सेमिनेटर जानकारी विवरण",
      updateInseminatorInfo: "इंसेमिनेटर जानकारी अपडेट करें"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "आदेश लोड हो रहे हैं... कृपया प्रतीक्षा करें",
      addStocks: "स्टॉक्स जोड़ें",
      addStock: "स्टॉक जोड़ें",
      quantity: "मात्रा",
      selectUnit: "इकाई का चयन करें",
      farmProducts: "कृषि उत्पाद",
      cost: "लागत",
      transactionID: "लेन-देन आईडी",
      recipientID: "प्राप्तकर्ता आईडी",
      orderID: "आदेश कामतत्व",
      recepientName: "प्राप्तकर्ता का नाम",
      createAOrder: "एक आदेश बनाएँ",
      totalStocks: "कुल स्टॉक",
      orders: "आदेश",
      totalPending: "कुल लंबित",
      totalDelivered: "कुल वितरित",
      searchByRecepientNameOrderIdRecepientId: "प्राप्तकर्ता का नाम, ऑर्डर आईडी, प्राप्तकर्ता आईडी द्वारा खोजें",
      chooseTheDate: "तिथि चुनें",
      transactionDate: "कार्यवाही की तिथि",
      selectCategory: "श्रेणी चुनना",
      volumeOfProduct: "उत्पाद की मात्रा",
      productQuantity: "उत्पाद गुणवत्ता",
      productRecipientId: "उत्पाद प्राप्तकर्ता आईडी",
      productRecipientName: "उत्पाद प्राप्तकर्ता का नाम",
      productRecipientType: "उत्पाद प्राप्तकर्ता प्रकार",
      singleProduct: "एकल उत्पाद",
      orderPlaced: "आदेश रखा",
      orderNotPlaced: "आदेश नहीं दिया गया",
      totalPrice: "कुल कीमत",
      currency: "मुद्रा",
      selectCurrency: "मुद्रा चुनें",
      address: "पता",
      enterAddress: "पता दर्ज करें",
      attachments: "संलग्नक",
      chooseFile: "फाइलें चुनें",
      nameOfTheFarm: "खेत का नाम",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "लोरेम इप्सम 1500 के दशक से उद्योग का मानक डमी टेक्स्ट रहा है, जब एक अज्ञात प्रिंटर ने",
      billedTo: "बिल किया गया",
      orderStatus: "आदेश की स्थिति",
      selectStatus: "स्थिति का चयन करें",
      cadbury: "कैडबरी",
      totalAmount: "कुल राशि",
      deliveryCharges: "वितरण शुल्क",
      orderDetails: "ऑर्डर का विवरण",
      deliveryOnTime: "समय पर डिलीवरी",
      productID: "उत्पाद आयडी",
      productRegistration: "उत्पाद पंजीकरण",
      enterTheNameOfTheProduct: "उत्पाद का नाम दर्ज करें",
      nameOfTheProduct: "उत्पाद का नाम",
      productAdded: "उत्पाद जोड़ा गया",
      productNotAdded: "उत्पाद नहीं जोड़ा गया"
    },
    drug: {
      dRUGS: "ड्रग्स",
      registerAdrug: "एक दवा पंजीकृत करें",
      sEARCH: "खोज",
      genericName: "वर्ग नाम",
      manufacturer: "उत्पादक",
      distributor: "वितरक",
      registrationDate: "पंजीकरण की तारीख",
      drugRegistration: "दवा पंजीकरण",
      drugInformation: "दवा की जानकारी",
      packExpiration: "पैक समाप्ति",
      drugId: "ड्रग आईडी",
      drugName: "दवा का नाम",
      drugGenericname: "ड्रग जेनरिक नाम",
      drugManufacturer: "दवा निर्माता",
      distributorName: "वितरक का नाम",
      drugRegistrationdate: "दवा पंजीकरण तिथि",
      nextDrug: "अगली दवा",
      editDrug: "दवा संपादित करें",
      updateDrug: "अद्यतन दवा",
      deleteDrug: "दवा हटाएं",
      noRecordfound: "कोई रिकॉर्ड नहीं मिला",
      addDrug: "दवा डालें",
      statementDrug: "दवा हटा दी गई है।  ",
      cANCEL: "रद्द करना",
      cONFIRM: "पुष्टि करना",
      sTATEMENT: "क्या आप वाकई इस रिकॉर्ड को मिटाना चाहते हैं?",
      ok: " ठीक",
      information: "जानकारी",
      packOrder: "पैक ऑर्डर",
      packPrescription: "पैक प्रिस्क्रिप्शन",
      packReservation: "पैक आरक्षण",
      packLocation: "पैक स्थान",
      drugDozedam: "डैम के लिए एक दिन में दवा की खुराक",
      drugDozecalf: "बछड़े के लिए एक दिन में दवा की खुराक",
      drugFormate: "औषधि प्रारूप",
      drugDistributor: "दवा वितरक",
      drugActiveingridents: "दवा सक्रिय सामग्री",
      drugSubstitutionId: "दवा प्रतिस्थापन आईडी",
      packId: "पैक आई.डी",
      packBatchNumber: "पैक बैच संख्या",
      drugIdStatement: "दवा का बैच नंबर।",
      drugNameSatement: "विज्ञापित ब्रांड नाम जिसके तहत दवा बेची जाती है।",
      drugGenericnameStatement: "विज्ञापित ब्रांड नाम के बजाय दवा की रासायनिक संरचना जिसके तहत दवा बेची जाती है।",
      drugFormateSatement: "दवा का बैच नंबर।",
      drugDozecalfSatement: "बछड़े को दी जाने वाली दवा की खुराक की मात्रा जानने के लिए।",
      drugDozedamStatement: "डैम को दवा के डोज की मात्रा जानने के लिए।",
      drugManufacturerStatement: "दवा निर्माता का विवरण।",
      drugDistributorStatement: "दवा वितरक का विवरण।",
      drugRegistrationdateStatement: "विशिष्ट देश में दवा पंजीकरण की तिथि।",
      drugActiveingridentsStatement: "सक्रिय अवयवों की सूची।",
      drugSubstitutionIdStatement: "मुख्य दवा वर्तमान में अनुपलब्ध होने की स्थिति में दवा के लिए संभावित प्रतिस्थापन की आईडी।",
      packIdStatement: "पैक का बार कोड या आरएफ आईडी।",
      packBatchNumberStatement: "निर्माता द्वारा पैक को आवंटित बैच संख्या।",
      locationWarehouseID: "स्थान गोदाम आईडी",
      locationWarehouseIDState: "उस गोदाम की आईडी जहां पैक रखा गया है।",
      locationRackID: "स्थान रैक आईडी",
      locationRackIDStatement: "उस रैक की आईडी जहां पैक रखा जाता है।",
      locationTierID: "स्थान टियर आईडी",
      locationTierIDStatement: "रैक पर उस स्तर का आईडी जहां पैक रखा जाता है।",
      locationPositionID: "स्थान स्थिति आईडी",
      locationPositionIDStatement: "उस स्तर पर स्थिति की आईडी जहां पैक संग्रहीत किया जाता है।",
      storageTemperatureCondition: "भंडारण तापमान की स्थिति",
      storageTemperatureConditionStats: "पैक भंडारण की स्थिति।",
      containerForm: "कंटेनर फॉर्म",
      containerFormStatement: "कंटेनर का रूप जिसमें दवा पैक की गई थी।",
      consistQuantity: "संगत मात्रा",
      consistQuantityStatement: "पैक में गोलियों, बोतलों आदि की मात्रा।",
      releaseId: "रिलीज आईडी",
      releaseIdStatement: "किसान द्वारा पैक लेने के बाद जो आईडी दी जाती है।",
      releaseDate: "रिलीज़ की तारीख",
      releaseDateStatement: "दिनांक जब किसान द्वारा स्टॉक से पैक लिया गया था।",
      packManufacturedDate: "निर्मित तिथि पैक करें",
      packManufacturedDateStatement: "दिनांक जब पैक निर्मित किया गया था।",
      packImportedDate: "आयातित दिनांक पैक करें",
      packImportedDateStatement: "दिनांक जब पैक आयात किया गया था।",
      packExpirationDate: "पैक समाप्ति तिथि",
      packExpirationDateStatement: "दिनांक जब पैक समाप्त हो गया है।",
      expiredSoonFlag: "जल्द ही समाप्त हो गया ध्वज",
      expiredSoonFlagState: "पैक के शीघ्र समाप्त होने की चेतावनी।",
      packTotalVolumeLeft: "कुल मात्रा बाएँ पैक करें",
      packTotalVolumeLeftState: "स्टॉक में समान सामग्री वाले पैक की कुल संख्या।",
      packOrderID: "पैक ऑर्डर आईडी",
      packOrderIDState: "आईडी जो डिस्ट्रीब्यूटर से पैक मंगवाने के बाद दी गई थी।",
      packQuantityOrdered: "पैक मात्रा का आदेश दिया",
      packQuantityOrderedState: "डिस्ट्रीब्यूटर से ऑर्डर किए गए पैक्स की संख्या।",
      packPrice: "पैक मूल्य",
      packPriceStatement: "पैक की कीमत।",
      priceCurrency: "मूल्य मुद्रा",
      packPricecurrency: "पैक मूल्य मुद्रा",
      packPricecurrencyState: "मुद्रा का नाम जिसमें मूल्य नामांकित है।",
      packPaydate: "पैक भुगतान तिथि",
      payDate: "भुगतान की तिथि",
      packPaydateState: "वह दिनांक जब वितरक को भुगतान जारी किया गया था।",
      packShippingID: "शिपिंग आईडी पैक करें",
      shippingID: "शिपिंग आईडी",
      packShippingIdState: "वितरक से आने पर पैक की शिपिंग आईडी।",
      packShippingDate: "शिपिंग तिथि पैक करें",
      shippingDate: "शिपिंग तारीख",
      packShippingDateState: "पैक के स्टॉक में आने की तारीख।",
      packOrderStatus: "पैक ऑर्डर की स्थिति",
      packOrderStatusState: "वर्तमान आदेश की स्थिति।",
      recepientKeeperId: "प्राप्तकर्ता कीपर आईडी",
      recepientKeeperIdStatement: "पैक प्राप्त करने वाले व्यक्ति/संगठन का नाम।",
      recepientFarmId: "प्राप्तकर्ता फार्म आईडी",
      recepientFarmIdStatement: "फार्म की पहचान पत्र जहां पशुलाल दवा की रसीद है।",
      recepientAnimalId: "प्राप्तकर्ता पशु आईडी",
      recepientAnimalIdState: "उस जानवर की आईडी जिसे दवा (पैक) निर्धारित की गई थी।",
      specialistComments: "विशेषज्ञ टिप्पणियाँ",
      specialistCommentsState: "नुस्खे के बारे में विशेषज्ञ/पशु चिकित्सा विशेषज्ञ की टिप्पणियाँ।",
      specialistName: "विशेषज्ञ का नाम",
      specialistNameState: "उस विशेषज्ञ/पशुचिकित्सक का नाम जिसने दवा निर्धारित की है।",
      specialistID: "विशेषज्ञ आईडी",
      specialistIDState: "दवा निर्धारित करने वाले विशेषज्ञ / पशु चिकित्सा की आईडी।",
      reservedByKeeperId: "कीपर आईडी द्वारा आरक्षित",
      reservedByKeeperIdState: "पैक आरक्षित करने वाले की कीपर आईडी।",
      reservedByFarmId: "फार्म आईडी द्वारा आरक्षित",
      reservedByFarmIdState: "फार्म आईडी जिसके लिए पैक आरक्षित है।",
      reservationTimeoutDate: "आरक्षण समय समाप्ति तिथि",
      reservationTimeoutDateState: "तिथि जब पैक नहीं खरीदा जाता है तो आरक्षण स्वचालित रूप से रद्द कर दिया जाएगा।",
      reservationTimeout: "आरक्षण टाइमआउट",
      reservationTimeoutState: "घंटों की संख्या जिसके बाद यदि पैक खरीदा या लिया नहीं जाता है तो आरक्षण स्वत: रद्द हो जाएगा",
      reservationDate: "आरक्षण तिथि",
      reservationDateState: "पैक की आरक्षण तिथि।",
      reservationStatus: "आरक्षण की स्थिति",
      reservationStatusState: "पैक आरक्षण की स्थिति। ",
      loadingDrugsPleaseWait: "दवाएं लोड हो रही हैं... कृपया प्रतीक्षा करें",
      quantityOrder: "मात्रा क्रम",
      keeperID: "रक्षक आईडी",
      timeoutDate: "समय समाप्ति तिथि",
      warehouseID: "गोदाम आईडी",
      rackID: "रैक आईडी",
      tierID: "टियर आईडी",
      positionID: "स्थिति आईडी",
      temperatureCondition: "तापमान की स्थिति",
      manufactureDate: "निर्माण दिनांक",
      importedDate: "आयातित तिथि",
      totalVolumeLeft: "कुल मात्रा बाएँ"
    },
    reports: {
      myReports: "मेरी रिपोर्ट",
      satelliteReports: "उपग्रह रिपोर्ट",
      weatherReports: "मौसम की रिपोर्ट",
      pregnancyAnalytics: "गर्भावस्था विश्लेषण",
      semenEmbroyAnalytics: "वीर्य/भ्रूण विश्लेषिकी",
      semenAnalytics: "वीर्य विश्लेषिकी",
      embryoAnalytics: "भ्रूण विश्लेषण",
      calfAnalytics: "बछड़ा विश्लेषण",
      milkProduction: "दुग्ध उत्पादन",
      totalMilkType: "कुल दूध का प्रकार",
      totalAnimalAnalytics: "कुल पशु विश्लेषण",
      animalAnalytics: "पशु विश्लेषण",
      analyticsAndReporting: "विश्लेषिकी और रिपोर्टिंग",
      filterByCountry: "देश के अनुसार फ़िल्टर करें",
      filterByFarm: "फार्म द्वारा फ़िल्टर करें",
      filterByRegion: "क्षेत्र द्वारा फ़िल्टर करें",
      filterByMonth: "महीने के हिसाब से फ़िल्टर करें",
      filterByDate: "तिथि के अनुसार फ़िल्टर करें",
      filterByRole: "भूमिका द्वारा फ़िल्टर करें",
      filterByYear: "वर्ष के अनुसार फ़िल्टर करें",
      filterByTrait: "विशेषता द्वारा फ़िल्टर करें",
      avgBreedingValue: "औसत प्रजनन मूल्य",
      avgEconomicIndex: "औसत आर्थिक सूचकांक",
      breederReport: "ब्रीडर रिपोर्ट",
      semenTransferDate: "वीर्य स्थानांतरण तिथि",
      semenEmbryoProductionReport: "वीर्य/भ्रूण उत्पादन रिपोर्ट",
      semenProducts: "वीर्य उत्पाद",
      meatProducts: "मांस उत्पादों",
      totalProducts: "कुल उत्पाद",
      semenEmbryoReport: "वीर्य/भ्रूण रिपोर्ट",
      numOfStraws: "तिनके की संख्या",
      collectionDate: "संग्रहण दिनांक",
      productionReport: "उत्पादन रिपोर्ट",
      receipientId: "प्राप्तकर्ता आईडी",
      embryoId: "भ्रूण आईडी",
      semenStrawId: "वीर्य स्ट्रॉ आईडी",
      dataScientist: "डेटा वैज्ञानिक",
      dataScientistReport: "डेटा वैज्ञानिक रिपोर्ट",
      productReport: "उत्पाद रिपोर्ट",
      dairyProducts: "डेयरी उत्पादों"
    },
    genoPerformance: {
      performanceOfGenoType: "जेनोटाइप का प्रदर्शन",
      addAGenoType: "एक जेनोटाइप जोड़ें",
      breedName: "नस्ल का नाम",
      chromosome: "क्रोमोसाम",
      sequenceChange: "अनुक्रम परिवर्तन",
      inheritance: "विरासत",
      diseaseName: "रोग का नाम",
      referenceSequence: "संदर्भ अनुक्रम",
      pubmedReference: "प्रकाशित संदर्भ",
      genoTypeRegistration: "जेनोटाइप पंजीकरण",
      breed: "नस्ल",
      editAGenoType: "एक जेनोटाइप संपादित करें",
      editGenoType: "जेनोटाइप संपादित करें",
      loadingGene: "जेनो लोड हो रहा है... कृपया प्रतीक्षा करें",
      geneTypeList: "जेनोटाइप सूची"
    },
    reportings: {
      conception: "गर्भाधान (डेटा वैज्ञानिक)",
      performanceOfGenoData: "जीनोटाइप का प्रदर्शन (डेटा वैज्ञानिक)",
      totalInsemination: "कुल गर्भाधान",
      embryo: "भ्रूण",
      animalVaccinationRecord: "पशु टीकाकरण रिकॉर्ड",
      dataNotAvailable: "इस फार्म के लिए डेटा उपलब्ध नहीं है।",
      pregnancyStatus: "गर्भावस्था की स्थिति",
      healthReport: "स्वास्थ्य रपट",
      heavyMilk: "भारी दूध",
      standardMilk: "मानक दूध"
    },
    sidebar: {
      healthAnalytics: "स्वास्थ्य विश्लेषिकी",
      productionAnalytics: "प्रोडक्शन एनालिटिक्स"
    },
    epd: {
      regNo: "एनिमल रेग नं विशिष्ट जानवरों को पहचानने और ट्रैक करने के लिए की जाने वाली प्रक्रिया को सुनिश्चित करने के लिए अंकन के साधनों का उपयोग करके जानवरों को दिया जाने वाला अनूठा कोड है",
      internationalID: "पशु की अंतर्राष्ट्रीय आईडी",
      location: "पशु जन्म का देश / क्षेत्र ",
      animalName: "जानवर का मानक नाम / नामकरण",
      gender: "जानवर का लिंग (नर/मादा)",
      additionalIDMethod: "जानवर की पहचान करने के लिए किस विधि का उपयोग किया गया था (जैसे कान का टैग, टैटू)",
      damID: "आईडी या पशु के बांध की पंजीकरण संख्या - एक जानवर की मादा माता / जैविक मां की संख्या की आईडी",
      sireId: "एक जानवर के नर माता-पिता की एक आईडी या पंजीकरण संख्या, विशेष रूप से प्रजनन के लिए रखे गए बैल या कृत्रिम गर्भाधान के लिए इस्तेमाल किए गए बैल के वीर्य।",
      dateOfBirth: "जानवर के जन्म की तारीख।",
      breederHerdCode: "ब्रीडर झुंड कोड ज्यादातर ब्रीडर संघों द्वारा दिया जाता है",
      seasonofBirth: "पशु के जन्म का मौसम माहवार नोट किया गया",
      birthYear: "जानवर के जन्म का वर्ष",
      birthManagementCode: "जन्म प्रबंधन कोड ज्यादातर उपयोगकर्ता/किसान द्वारा प्रदान किया जाता है",
      birthSex: "जानवर का लिंग (पुरुष/महिला)",
      birthWeight: "बछड़े का जन्म वजन ",
      primaryBreed: "जानवर का प्रमुख% आनुवंशिक योगदान ",
      secondaryBreed: "जानवर का मामूली% आनुवंशिक योगदान ",
      breedComposition: "नस्ल संरचना प्रतिशत एक अलग जानवर या जानवरों के समूह के अनुवांशिक मेकअप के भीतर विभिन्न नस्लों के आनुपातिक प्रतिनिधित्व को संदर्भित करता है। ",
      conceptionMethod: "जानवर की कल्पना कैसे की गई (प्राकृतिक संभोग/गर्भाधान/भ्रूण स्थानांतरण)।",
      accuracyWeight: "सटीकता वजन",
      damAge: "बांध की आयु महीनों/वर्षों में उदा. ",
      weaningWeight: "दूध छुड़ाने के समय पशु का वजन।",
      weaningDate: "वह तारीख जिस दिन पशु का दूध छुड़ाया गया था",
      weaningSex: "उस जानवर का लिंग जिसका दूध छुड़ाया गया था। ",
      managementPastureCode: "उपयोगकर्ता/किसान द्वारा प्रबंधन/चारागाह को दिया गया कोड ",
      creep: "रेंगना आहार नर्सिंग बछड़ों को पूरक आहार (अनाज या चारा) प्रदान करने की प्रथा है।",
      weaningContemporaryGroupCode: "वीनिंग वेट कंटेम्परेरी ग्रुप का कोड",
      birthContemporaryCode: "जन्म समकालीन कोड",
      yearlingDate: "पशु की एक वर्ष की आयु या उसकी आयु के दूसरे वर्ष की तिथि",
      managementFeedUnitCode: "उपयोगकर्ता द्वारा प्रबंधन/फ़ीड यूनिट को दिया गया कोड",
      yearlingSex: "वर्षण के समय पशु का लिंग ",
      yearlingWeight: "वार्षिक वजन दूध छुड़ाने के बाद की प्रत्यक्ष वृद्धि का माप है और इसका उपयोग अक्सर फीडलॉट में बाजार-बद्ध संतति के संभावित प्रदर्शन को दर्शाने के लिए किया जाता है, जिसे बछड़े के पाउंड में मापा जाता है।",
      yearlingHeight: "वर्षण के समय पशु की ऊँचाई ",
      yearlingWeightContemporaryGroupCode: "वार्षिक भार समसामयिक समूह का कोड",
      weaningYearlingWeightContemporaryGroupCode: "वीनिंग या ईयरलिंग वेट कंटेम्परेरी ग्रुप का कोड",
      daysOnFeed: "उस विशेष फ़ीड के साथ खिलाए गए दिनों की संख्या उदा: युवा बढ़ते मवेशियों को लाभ की कम लागत पर विपणन योग्य बीफ़ का उत्पादन करने के लिए उच्च-ऊर्जा आहार खिलाया जाता है। ",
      managementFeedUnitPenCode: "उपयोगकर्ता द्वारा प्रबंधन/फीड यूनिट/पेन को दिया गया कोड",
      harvestDate: "मांस के लिए मारे गए जानवर की तारीख",
      gradingDate: "शवों की तिथि एक विशेष मानदंड के अनुसार वर्गीकृत की गई थी",
      carcassSex: "शव का लिंग",
      dateonFeed: "वह तिथि जब पशु को नए चारे पर स्थानांतरित किया गया था उदा: युवा बढ़ते मवेशियों को उच्च-ऊर्जा आहार दिया जाता है ताकि लाभ की कम लागत पर विपणन योग्य बीफ़ का उत्पादन किया जा सके। ",
      KPH: "% KPH विशेष रूप से गुर्दे, श्रोणि और हृदय के क्षेत्रों में शव के शरीर गुहा में पाए जाने वाले कुल वसा का प्रतिशत है। ",
      carcassWeight: "लोथ वजन कटाई के बाद और खाल, सिर, जठरांत्र संबंधी मार्ग और आंतरिक अंगों को हटाने के बाद गर्म या बिना ठंडा वजन होता है। ",
      fatThickness: "एक छोटे शासक का उपयोग करके वसा की मोटाई इंच में मापी जाती है। ",
      marbling: "मार्बलिंग दिखाई देने वाला असंतृप्त (स्वस्थ) इंट्रामस्क्युलर वसा है जो मांसपेशियों के भीतर और मांसपेशी फाइबर बंडलों के बीच जमा होता है।",
      ribeyeArea: "एक ग्रिड (जैसे, 8, 9 या 10 इंच) का उपयोग करके वर्ग इंच में 12 वीं और 13 वीं पसलियों के बीच मापी गई रिब-आई (लॉइन या रिबेय मसल लॉन्गिसिमस डॉर्सी) क्षेत्र। ",
      animalStatus: "फार्म में पशु की स्थिति जैसे: फार्म पर, बेचा, मरा आदि"
    },
    manageAnimalGroupings: {
      maintainanceModeHeadingTooltip: "एक बार रीसेट (मोड) को अंतिम रूप देने के बाद, आप रखरखाव मोड में प्रवेश करेंगे जहां रीसेट पर गणना की गई ईडीपी अगले रीसेट (जो 2-6 महीने दूर हो सकती है) तक प्रत्येक जानवर के लिए स्थिर रखी जाएगी। ",
      maintainanceModeTooltip: "रीसेट मोड पूरा करने के बाद, सभी जानवरों के ईपीडी की गणना करने के लिए सिस्टम को सक्षम करने के लिए रीसेट अंतिम बटन दबाएं, रीसेट मोड को समाप्त करें और रखरखाव मोड शुरू करें।",
      resetToggleTooltip: "जानवरों को सीजी को असाइन करने के लिए ईपीडी मॉडल सेटिंग में रीसेट टॉगल को सक्षम करें।"
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "आनुवंशिकी",
      geneticSearchTool: "जेनेटिक सर्च टूल",
      dataSubmission: "डेटा सबमिशन",
      animalsWithExpectedProgenyDifferences: "अपेक्षित संतति अंतर वाले पशु (ईपीडी)",
      searchByAnimalIdName: "एनिमल आईडी, नाम से खोजें",
      rowsPerPage: "प्रति पृष्ठ पंक्तियाँ",
      individualEntry: "व्यक्तिगत प्रवेश",
      bulkEntry: "थोक प्रविष्टि",
      registerANewAnimalOrSelectAnExistingAnimal: "एक नए जानवर का पंजीकरण करें या किसी मौजूदा जानवर का चयन करें।",
      registerNewAnimal: "नया जानवर रजिस्टर करें",
      selectExistingAnimal: "मौजूदा पशु का चयन करें",
      animalID: "पशु आईडी",
      animalName: "पशु का नाम",
      tag: "उपनाम",
      dateOfBirth: "जन्म की तारीख",
      gender: "लिंग",
      birthDate: "जन्म तिथि",
      birthWeightLb: "जन्म वजन (एलबी)",
      birthWeightKg: "जन्म वजन (किग्रा)",
      weaningWeightLb: "प्रातः वजन (पौंड)",
      weaningWeightKg: "वीनिंग वेट (किग्रा)",
      yearlingWeightLb: "वार्षिक वजन (पौंड)",
      yearlingWeightKg: "वार्षिक वजन (किग्रा)",
      carcassWeightLb: "शव वजन (एलबी)",
      carcassWeightKg: "शव वजन (किग्रा)",
      animalSelection: "पशु चयन",
      animalSearchTool: "पशु खोज उपकरण",
      back: "पीछे",
      searchByEPDs: "ईपीडी द्वारा खोजें",
      searchByIds: "आईडी द्वारा खोजें",
      selectBreed: "नस्ल का चयन करें",
      selectGender: "लिंग चुनें",
      selectRequiredBreedForCattle: "मवेशियों के लिए आवश्यक नस्ल का चयन करें",
      resetFilter: "फ़िल्टर रीसेट करें",
      birthWeightHeader: "जन्म वजन (बीडब्ल्यू): ",
      birthWeightDef: "जन्म के समय बछड़ों के वजन में अंतर की तुलना करता है और इसे पाउंड या किलोग्राम में मापा जाता है।",
      weaningWeightHeader: "वीनिंग वेट (WW): ",
      weaningWeightDef: "डब्ल्यूडब्ल्यू ईपीडी दूध छुड़ाने से पहले की वृद्धि का अनुमान है जिसे पाउंड या किग्रा में मापा जाता है।",
      yearlingWeightHeader: "सालाना वजन (वाईडब्ल्यू): ",
      yearlingWeightDef: "वाईडब्ल्यू ईपीडी वीनिंग के बाद की वृद्धि का अनुमान है जिसे पाउंड या किग्रा में मापा जाता है।",
      ribEyeAreaHeader: "रिबे क्षेत्र (आरईए): ",
      ribEyeAreaDef: "आरईए मांसपेशियों के आकार को मापता है जो हमें वर्ग इंच में रिब आई देता है। आरई ईपीडी कटे हुए मवेशियों के शव माप के आधार पर समायोजित 365-दिवसीय रिबे क्षेत्र माप में अंतर को दर्शाता है।",
      marblingHeader: "मार्बलिंग (MARB): ",
      marblingDef: "मारब ईपीडी राइब आई के भीतर इंट्रामस्क्युलर वसा के प्रतिशत की इकाइयों में है। मारब ईपीडी कटे हुए मवेशियों के शव माप के आधार पर समायोजित 365-दिवसीय मार्बलिंग स्कोर (इंट्रामस्क्युलर वसा, [आईएमएफ]) में अंतर को दर्शाता है।",
      fatThicknessHeader: "वसा की मोटाई (वसा): ",
      fatThicknessDef: "बैकफैट के इंच (एक इंच के सौवें हिस्से में) एफटी के लिए माप की इकाई है।",
      carcassWeightHeader: "शव वजन (सीडब्ल्यू): ",
      carcassWeightDef: "अंतिम उत्पाद मूल्य के सापेक्ष पाउंड के प्रभाव पर विचार करते समय शव वजन एक लाभकारी विशेषता है। ",
      yieldGradeHeader: "उपज ग्रेड (YG): ",
      yieldGradeDef: "यूएसडीए यील्ड ग्रेड स्कोरिंग सिस्टम वाईजी ईपीडी के लिए माप की इकाई है। ",
      milkHeader: "दूध (एमके): ",
      milkDef: "एमके ईपीडी को उसकी मां की दूध देने की क्षमता के कारण बछड़े के वजन के पाउंड में मापा जाता है।",
      totalMaternalHeader: "कुल मातृ (टीएम): ",
      totalMaternalDef: "टीएम दूध उत्पादन और वृद्धि के लिए गाय के आनुवंशिकी दोनों के कारण बछड़े के वजन पर प्रभाव को मापता है।",
      calvingEaseDirectHeader: "कैल्विंग ईज़ी डायरेक्ट (सीईडी): ",
      calvingEaseDirectDef: "CED EPD को बिना सहायता वाले बछड़ों के प्रतिशत के रूप में सूचीबद्ध किया गया है।",
      calvingEaseMaternalHeader: "कैल्विंग आसानी मातृ (सीईएम): ",
      calvingEaseMaternalDef: "एक बैल की बेटियों की दो साल की उम्र में बिना सहायता के बछड़ों की क्षमता को मापता है।",
      stayabilityHeader: "स्थिरता (रहना): ",
      stayabilityDef: "ST EPD गायों को पालने के लिए एक बैल की क्षमता की भविष्यवाणी करता है जो \"चारों ओर रहें\"।",
      docilityHeader: "विनम्रता (डीओसी): ",
      docilityDef: "डीओसी मवेशियों के स्वभाव को मापता है।",
      max: "मैक्स",
      min: "मिन",
      accuracy: "शुद्धता",
      sortBy: "इसके अनुसार क्रमबद्ध करें",
      traits: "स्लेटी रंग में प्रदर्शित लक्षण विकास के अधीन हैं, जो कि 2023 की दूसरी तिमाही में आ रहे हैं।",
      searchResults: "खोज के परिणाम",
      recordsFound: "अभिलेख मिले",
      compareSelected: "चयनित की तुलना करें",
      animalIdentification: "पशु पहचान",
      errorMessage: {
        birthWeight: "बर्थ वेट मैक्सिमम वैल्यू बर्थ वेट मिनिमम से कम नहीं हो सकता",
        weaningWeight: "दूध छुड़ाने का अधिकतम वजन दूध छुड़ाने के न्यूनतम वजन से कम नहीं हो सकता",
        yearlingWeight: "वार्षिक भार का अधिकतम मान वार्षिक भार के न्यूनतम से कम नहीं हो सकता",
        carcassWeight: "शव वजन अधिकतम मूल्य न्यूनतम जन्म वजन से कम नहीं हो सकता",
        fatThickness: "वसा की मोटाई का अधिकतम मान दूध छुड़ाने के न्यूनतम वजन से कम नहीं हो सकता",
        marbling: "मार्बलिंग का अधिकतम मूल्य वार्षिक वजन के न्यूनतम से कम नहीं हो सकता",
        ribeyeArea: "रिबे क्षेत्र का अधिकतम मूल्य जन्म के न्यूनतम वजन से कम नहीं हो सकता",
        yieldGrade: "यील्ड ग्रेड अधिकतम मूल्य वीनिंग वजन न्यूनतम से कम नहीं हो सकता",
        milk: "दूध का अधिकतम मूल्य दूध छुड़ाने के न्यूनतम वजन से कम नहीं हो सकता",
      },
      reg: "रेग",
      name: "नाम",
      sex: "लिंग",
      tattoo: "टटू",
      dob: "जन्म तिथि",
      EPD: "ईपीडी",
      rank: "पद",
      searchValue: "खोज मूल्य",
      typeHere: "यहाँ टाइप करें",
      searching: "खोज कर...",
      fetchingResult: "परिणाम प्राप्त हो रहे हैं...कृपया प्रतीक्षा करें",
      animalsMatchedYourCriteria: "जानवर आपके मानदंड से मेल खाते हैं",
      manageAnimalsGrouping: "पशु समूहन प्रबंधित करें",
      manageAnimalGroupings: "पशु समूहों का प्रबंधन करें",
      assignAnimalToContemporaryGroups: "समसामयिक समूहों को पशु सौंपें",
      resetMode: "रीसेट मोड",
      enterResetMode: "रीसेट मोड दर्ज करें",
      maintainanceMode: "रखरखाव मोड",
      assigningAnimals: "जानवरों को सौंपना",
      excludedAnimals: "बहिष्कृत पशु",
      ungroupedAnimals: "असमूहीकृत पशु",
      assignAnimalsToCGS: "जानवरों को सीजीएस को सौंपें",
      reset: "रीसेट",
      excludeAnimals: "जानवरों को छोड़ दें",
      resetToMaintainanceMode: "रीसेट को अंतिम रूप दिया गया - रखरखाव मोड में बदलें",
      contemporaryGroupsSettings: "समकालीन समूह (सीजी) सेटिंग्स",
      selectTrait: "विशेषता का चयन करें",
      selectTraitDescription:"चयन विशेषता एक विशिष्ट विशेषता को चुनने की प्रक्रिया को संदर्भित करती है",
      traitsType: {
        birthWeight: "जन्म के समय वजन",
        weaningWeight: "वीनिंग वेट",
        yearlingWeight: "वार्षिक वजन",
        carcassWeight: "लाश का वजन"
      },
      addNewGroup: "नया समूह जोड़ें",
      contemporaryGroup: "समकालीन समूह",
      contemporaryGroups: "समकालीन समूह",
      editGroup: "समूह संपादित करें",
      birthCGCode: "जन्म (सीजी) कोड",
      groupName: "समूह नाम",
      birthSex: "जन्म लिंग",
      conceptionMethod: "गर्भाधान विधि",
      weaningCGCode: "वीनिंग (सीजी) कोड",
      yearlingCGCode: "ईयरलिंग (सीजी) कोड",
      dateWeight: "दिनांक वजन",
      weaningyearlingCGcode: "वीनिंग/ईयरलिंग (सीजी) कोड",
      carcassCGCode: "कारकस (सीजी) कोड",
      breedOfDom: "डोम की नस्ल",
      addNewContemporaryGroup: "नया समकालीन समूह जोड़ें",
      createNewGroup: "नया समूह बनाएँ",
      selectFromDifferentTraits: "विभिन्न लक्षणों में से चुनें",
      contemporaryGroupName: "समकालीन समूह का नाम",
      enterNameHere: "यहाँ नाम दर्ज करें",
      groupNameIsRequired: "समूह का नाम आवश्यक है",
      birthYearRange: "जन्म वर्ष सीमा",
      theYearAnimalWasBorn: "पशु का जन्म किस वर्ष हुआ",
      birthYearIsRequired: "जन्म वर्ष आवश्यक है",
      genderOfNewBornAnimal: "नवजात पशु का लिंग",
      selectSex: "सेक्स का चयन करें",
      theweightOfAnimalAtBirth: "जन्म के समय पशु का वजन",
      maximumKg: "अधिकतम (किग्रा)",
      minimumKg: "न्यूनतम (किग्रा)",
      aSeasonisAPeriodOfYear: "एक मौसम वर्ष की एक अवधि है जो विशेष जलवायु परिस्थितियों से अलग होती है।",
      seasonofBirthIsRequired: "जन्म का मौसम आवश्यक है",
      majorGenericContributionOfAnimal: "पशु का प्रमुख% सामान्य योगदान",
      primaryBreedCompostionIsRequired: "प्राथमिक नस्ल खाद की आवश्यकता है",
      secondaryBreedCompostionIsRequired: "द्वितीयक नस्ल खाद की आवश्यकता है",
      howTheAnimalWasConceived: "जानवर की कल्पना कैसे की गई (प्राकृतिक संभोग/गर्भाधान/भ्रूण स्थानांतरण)",
      conceptionMethodIsRequired: "गर्भाधान विधि की आवश्यकता है",
      epdModelSettings: "ईपीडी मॉडल सेटिंग्स",
      forResetMode: "रीसेट मोड के लिए",
      progenyWeightingFactor: "संतान भार कारक",
      weightGivenToTheProgenyFactor: "रीसेट मोड में ईपीडी गणना के लिए सीजी कारक के सापेक्ष संतान कारक को दिया गया वजन। ",
      enterNumber: "नंबर डालें",
      enterBreed: "नस्ल दर्ज करें",
      valueShouldBeBetween0and1: "मान 0 और 1 के बीच होना चाहिए",
      resetDuration: "अवधि रीसेट करें",
      timeIntervalBetweenLastAndFirstResetMode: "अंतिम और नए रीसेट मोड के बीच का समय अंतराल, जिसके अंत में नया रीसेट मोड सक्षम होता है और नए सीजी और ईपीडी की गणना की जाती है।",
      enterNumberOfDays: "दिनों की संख्या दर्ज करें",
      valueCannotBeNegative: "मान ऋणात्मक नहीं हो सकता!",
      criticalProgenyPopulation: "गंभीर संतति जनसंख्या",
      minimumNumberOfProgenyRecords: "50% से अधिक संतति सटीकता (APD1) प्राप्त करने के लिए आवश्यक प्रणाली में प्रत्येक पशु के संतति रिकॉर्ड की न्यूनतम संख्या (वंशावली सटीकता के लिए)",
      criticalAncestorPopulation: "गंभीर पूर्वज जनसंख्या",
      minimumNumberOfAncestorsRecords: "50% से अधिक पूर्वज सटीकता (APD4) प्राप्त करने के लिए आवश्यक प्रणाली में व्यक्तिगत पशु के पूर्वजों के रिकॉर्ड की न्यूनतम संख्या (वंशावली सटीकता के लिए)",
      forBirthWeightCG: "जन्म वजन सीजी के लिए",
      criticalPopulationInAnimalsContemporaryGroup: "पशु के समकालीन समूह में गंभीर जनसंख्या",
      minimumAverageNumberOfAnimalsPerBirthWeight: "50% से ऊपर औसत सीजी सटीकता (ACG3) प्राप्त करने के लिए प्रति जन्म भार CG में जानवरों की न्यूनतम औसत संख्या आवश्यक है",
      criticalAveragePopulationPerContemporaryGroup: "गंभीर औसत जनसंख्या प्रति समकालीन समूह",
      minimumNumberOfAnimalsInBirthWeight: "50% से अधिक CG सटीकता (ACG2) प्राप्त करने के लिए पशु के जन्म भार CG में पशुओं की न्यूनतम संख्या आवश्यक है",
      forWeaningWeightCG: "वीनिंग वेट सीजी के लिए",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "50% से ऊपर औसत सीजी सटीकता (ACG3) प्राप्त करने के लिए प्रति वीनिंग वज़न CG के लिए जानवरों की न्यूनतम औसत संख्या आवश्यक है",
      minimumNumberOfAnimalsInWeaningWeight: "50% से अधिक CG सटीकता (ACG2) प्राप्त करने के लिए पशु के वीनिंग वजन CG में पशुओं की न्यूनतम संख्या आवश्यक है",
      forYearlingWeightCG: "सालाना वजन सीजी के लिए",
      minimumAverageNumberOfAnimalsPerYearling: "50% से ऊपर औसत सीजी सटीकता (ACG3) प्राप्त करने के लिए प्रति वर्ष सीजी जानवरों की न्यूनतम औसत संख्या आवश्यक है",
      minimumNumberOfAnimalsInYearlingWeight: "50% से अधिक CG सटीकता (ACG2) प्राप्त करने के लिए आवश्यक पशु के वार्षिक वजन CG में पशुओं की न्यूनतम संख्या",
      forCarcassCG: "कैरस सीजी के लिए",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "50% से ऊपर औसत सीजी सटीकता (ACG3) प्राप्त करने के लिए प्रति शव भार CG के लिए जानवरों की न्यूनतम औसत संख्या आवश्यक है",
      minimumNumberOFAnimalInCarcassWeight: "50% से अधिक CG सटीकता (ACG2) प्राप्त करने के लिए पशु के शव भार CG में पशुओं की न्यूनतम संख्या आवश्यक है",
      epdRequiredFieldSettings: "EPD आवश्यक फ़ील्ड सेटिंग्स",
      pleaseSelectRequiredFieldsForCompleteEPD: "पूर्ण ईपीडी गणना के लिए कृपया आवश्यक फ़ील्ड का चयन करें",
      byDefault: "डिफ़ॉल्ट रूप से",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "नोट: कृपया ध्यान दें कि यदि उपयोगकर्ता आवश्यक के रूप में चिह्नित किए गए डेटा फ़ील्ड प्रदान नहीं करते हैं तो उपयोगकर्ता पूर्ण ईपीडी गणना प्राप्त करने में सक्षम नहीं होंगे।",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "नोट: कृपया ध्यान दें कि आवश्यक फ़ील्ड पैरामीटर बदले नहीं जा सकते क्योंकि पिछले पैरामीटर के विरुद्ध पहले से ही समसामयिक समूह मौजूद हैं।",
      noResultFound: "कोई परिणाम नहीं मिला",
      next: "अगला",
      cancel: "रद्द करना",
      selectAnimal: "पशु का चयन करें",
      searchBy: "खोज से",
      breed: "नस्ल",
      regDate: "रेग। ",
      status: "दर्जा",
      animalDetails: "पशु विवरण",
      add: "जोड़ना",
      update: "अद्यतन",
      dataForEPDs: " ईपीडी के लिए डेटा",
      basicInformation: "मूल जानकारी",
      birthWeightInformation: "जन्म वजन की जानकारी",
      weaningWeightInformation: "वीनिंग वजन की जानकारी",
      yearlingWeightInformation: "वार्षिक वजन की जानकारी",
      carcassWeightInformation: "शव वजन की जानकारी",
      delete: "मिटाना",
      deleteEpdData: "ईपीडी डेटा हटाएं",
      areYouSureYouWantToDeleteEpdData: "क्या आप वाकई ईपीडी डेटा हटाना चाहते हैं।",
      internationalID: "अंतर्राष्ट्रीय आईडी",
      enterID: "आईडी दर्ज करें",
      animalRegistration: "पशु पंजीकरण",
      location: "जगह",
      additionalIDMethod: "अतिरिक्त आईडी विधि",
      damID: "डैम आईडी",
      sireID: "साहब आईडी",
      breederHerdCode: "ब्रीडर हर्ड कोड",
      birthYear: "जन्म वर्ष",
      primaryBreed: "प्राथमिक नस्ल",
      breedComposition: "नस्ल रचना",
      secondaryBreed: "माध्यमिक नस्ल",
      seasonofBirth: "जन्म का मौसम",
      birthManagementCode: "जन्म प्रबंधन कोड",
      damAge: "आघात",
      years: "साल",
      birthContemporaryCode: "जन्म समकालीन कोड",
      accuracyWeight: "सटीकता वजन",
      note: "टिप्पणी",
      minimumRequiredFieldForBirthWeight: "बर्थ वेट ईपीडी के लिए न्यूनतम आवश्यक फ़ील्ड",
      birthYearGenderConceptionMethodBirthWeight: "जन्म वर्ष, लिंग, गर्भाधान विधि, जन्म वजन",
      weaningWeight: "वीनिंग वेट",
      weaningDate: "वीनिंग डेट",
      weaningContemporaryGroupCode: "वीनिंग कंटेम्पररी ग्रुप कोड",
      creep: "रेंगना",
      managementPastureCode: "प्रबंधन/चारागाह कोड",
      weaningSex: "वीनिंग सेक्स",
      minimumRequiredFieldForWeaningWeight: "वीनिंग वेट ईपीडी के लिए न्यूनतम आवश्यक फ़ील्ड",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "वीनिंग वेट, मैनेजमेंट/पाश्चर कोड, वीनिंग सेक्स, वेटेड डेट",
      yearlingWeight: "वार्षिक वजन",
      yearlingHeight: "वार्षिक ऊंचाई",
      yearlingDate: "वार्षिक तिथि",
      yearlingContemporaryGroupCode: "वार्षिक समकालीन समूह कोड",
      managementFeedingCode: "प्रबंधन / खिला कोड",
      yearlingSex: "एक बरस का सेक्स",
      youWillNeedToFillOutFor: "ईपीडी डेटा पुनर्प्राप्त करने के लिए आपको सभी फ़ील्ड भरने होंगे",
      pleaseSelectHavestDateFirstToEnterInfo: "रिब आई एरिया, फैट थिकनेस और मार्बलिंग के लिए जानकारी दर्ज करने के लिए कृपया 'हार्वेस्ट डेट' चुनें",
      harvestDate: "कटाई की तारीख",
      dateOnFeed: "फ़ीड पर दिनांक",
      daysOnFeed: "फ़ीड पर दिन",
      gradingDate: "ग्रेडिंग तिथि",
      carcassSex: "शव सेक्स",
      carcassWeight: "लाश का वजन",
      carcassContemporary: "शव समकालीन",
      damBreed: "बांध नस्ल",
      ribEyeArea: "रिब आई एरिया",
      ribEyeAreaContemporary: "रिब आई एरिया समकालीन",
      fatThickness: "वसा की मोटाई",
      fatThicknessContemporary: "मोटी मोटाई समकालीन",
      marbling: "marbling",
      marblingContemporary: "मार्बलिंग समकालीन",
      yieldGradeContemporary: "उपज ग्रेड समकालीन",
      animalsNotListedInContemporaryGroupsMsg: "लापता जानकारी के कारण जानवरों को किसी भी समकालीन समूह में नहीं जोड़ा गया है। ",
      listOfUngroupedAnimals: "अवर्गीकृत जानवरों की सूची",
      submittingData: "डेटा सबमिट करना",
      resendToUser: "उपयोगकर्ता को पुनः भेजें",
      submittingAnimalsInGroupMsg: "अपने जानवरों को समूहों में जमा करना। ",
      pressingResetBtnMsg: "\"रीसेट\" बटन दबाने से जानवरों को उनके समकालीन समूहों को पुन: असाइन करने की प्रक्रिया शुरू हो जाएगी।",
      doYouWantToProceed: "क्या आपकी आगे बढ़ने की इच्छा है ?",
      systemMaintainanceModeMsg: "\"रखरखाव मोड में बदलें\" बटन दबाने से एक प्रक्रिया शुरू हो जाएगी और आपका सिस्टम \"रखरखाव मोड\" में प्रवेश करेगा जहां रीसेट पर गणना की गई ईडीपी अगले रीसेट तक प्रत्येक जानवर के लिए स्थिर रखी जाएगी (जो 1-6 महीने हो सकती है)" ,
      errorFetchingContemporaryGrpMsg: "समकालीन समूह डेटा लाने में त्रुटि",
      deleteSuccess: "सफलता हटाएं",
      deleteSuccessMsg: "समकालीन समूह सफलतापूर्वक हटा दिया गया।",
      deleteFailed: "हटाना विफल",
      deleteFailedMsg: "समसामयिक समूह डेटा हटाने में त्रुटि",
      deleteContemporaryGrpMsg: "क्या आप वाकई इस समकालीन समूह को हटाना चाहते हैं?",
      addBirthWeightData: "जन्म वजन डेटा जोड़ें",
      addWeaningWeightData: "वीनिंग वेट डेटा जोड़ें",
      birthWeightContemporaryGroupCode: "जन्म वजन समकालीन समूह कोड",
      dateWeighted: "दिनांक भारित",
      addYearlingWeightData: "वार्षिक वजन डेटा जोड़ें",
      addCarcassWeightData: "शव वजन डेटा जोड़ें",
      weaningOrYearlingContemporaryGroupCode: "वीनिंग या ईयरलिंग वेट कंटेम्परेरी ग्रुप कोड",
      deleteContemporaryGroupMsg: "क्या आप वाकई समसामयिक समूह को हटाना चाहते हैं?",
      updateSuccessMsg: "समकालीन समूह सफलतापूर्वक अपडेट किया गया।",
      errorMsg: "कुछ गलत हो गया। ",
      fetchErrorMsg: "चयनित विशेषता के लिए आवश्यक फ़ील्ड लाने में त्रुटि।",
      forMaintainanceMode: "रखरखाव मोड के लिए",
      ancestorsWeightFactor: "पूर्वजों का वजन कारक",
      weightGivenToTheAncestorFactor: "रखरखाव मोड में ईपीडी गणना के लिए सीजी कारक के सापेक्ष पूर्वज कारक को दिया गया भार। ",
      addEPDModelSettingsData: "EPD मॉडल सेटिंग डेटा जोड़ें",
      minimumNumberOfAnimalsInContemporaryGroups: "समकालीन समूहों में जानवरों की न्यूनतम संख्या",
      enterNumberOfAnimals: "जानवरों की संख्या दर्ज करें",
      areYouSureYouWantToChangeEPDCalculation: "क्या आप वाकई आवश्यक EPD गणना फ़ील्ड बदलना चाहते हैं?",
      weightOfAnimalAtBirth: "जन्म के समय पशु का वजन",
      seasonIsAPeriodOfYear: "एक मौसम वर्ष की एक अवधि है जो विशेष जलवायु परिस्थितियों से अलग होती है।",
      codeOfBirthWeightContemporaryGroup: "जन्म भार समकालीन समूह का कोड",
      weaningWeightOfCalf: "बछड़े का दूध छुड़ाना",
      dateAnimalWasWeaned: "जिस तारीख को जानवर का दूध छुड़ाया गया था",
      genderOfWeaningAnimal: "प्रातः पशु का लिंग",
      yearlingWeightOfCalf: "बछड़े का एक साल का वजन",
      dateAnimalWasWeighted: "जिस तारीख को जानवर का वजन किया गया था",
      yearledAnimalSex: "उस जानवर का लिंग जो एक साल का था",
      dateOfAnimalKilledForMeat: "मांस के लिए मारे गए जानवर की तारीख",
      addSuccessMsg: "समकालीन समूह सफलतापूर्वक जोड़ा गया",
      traitH: "EPD गणना के लिए विशेषता।",
      searchByValue: "पंजीकरण संख्या/टैटू/नाम/टैग दर्ज करें"
    }
  }